<style lang="stylus">
        .editEChart_maintitle
            right-view-toggle-topbar()
        .echartSet_changeType
            position relative
            margin 0 auto
            display flex
            justify-content center
            .echartSet_changeBtn
                margin 0 auto
                margin-top 18px
                min-width 150px
                padding 0px 10px
                height 30px
                box-sizing border-box
                text-overflow ellipsis
                white-space nowrap
                overflow hidden
                border-radius 3px
                text-align center
                line-height 28px
                background-color #fff
                border 1px solid var(--themeColor)
                cursor pointer
                user-select none
                transition all .2s linear
                font-size 12px
                color $right-view-content-textcolor
                &:hover
                    color #fff
                    background-color var(--themeColor)
            .active
                color #fff
                background-color var(--themeColor)
            .echartSet_changeContent
                position absolute
                left 0px
                right 0
                margin 0 auto
                width 270px
                overflow auto
                padding 14px 10px
                border-radius 5px
                background-color #fff
                box-shadow $box-shadow
                max-height 900px
                z-index 1
                .changeType-line
                    margin-bottom 10px
                    overflow auto
                    padding-bottom 2px
                    .changeType-title
                        margin-bottom 5px
                    .changeType-imgbox
                        float left
                        width 78px
                        height 78px
                        border 1px solid transparent
                        cursor pointer
                        user-select none
                        margin 0 2px
                        // &:not(:nth-child(4n))
                        //     margin-right 8px
                        img
                            width 100%
                            height 100%
                            object-fit contain
                        .imgbox-svg
                            width 100%
                            height 100%
        .echartSet_container
            width 100%
            padding 14px 0
            background-color $right-view-backcolor
            border-bottom-left-radius $right-view-radius
            border-bottom-right-radius $right-view-radius
            .echartSet_box
                position relative
                min-height 30px
                padding 0 15px
                margin-bottom 10px
                width 100%
                border-bottom 1px solid $box-bordercolor
                &.bottomNone
                    border-bottom 0
                .map-style
                    display flex
                    justify-content space-between
                    padding-bottom 10px
                    .listbox_color
                        width 18px
                        width 18px
                        border-radius 5px
                        border 1px solid #a0a0a0
                .editEChart_title
                    font-size 12px
                    padding-bottom 5px
                    font-weight bold
                    color $right-view-content-textcolor
                    cursor pointer
                    user-select none
                    &.map-region
                        display flex
                        align-items center
                        justify-content space-between
                    .item-arrow
                        position absolute
                        width 10px
                        height 10px
                        left -13px
                        top 3px
                    .hiddren-arrow
                        transform rotate(-90deg)

                .echartSet_content
                    margin-top 10px

                    .region_changeBtn
                        color #fff
                        background var(--themeColor)
                        margin 0 auto
                        margin-top 18px
                        width 150px
                        padding 0px 10px
                        height 30px
                        box-sizing border-box
                        text-overflow ellipsis
                        white-space nowrap
                        overflow hidden
                        border-radius 3px
                        text-align center
                        line-height 28px
                        border 1px solid var(--themeColor)
                        cursor pointer
                        user-select none
                        font-size 12px
                    .region-checkbox
                        display flex
                        align-items center
                        justify-content space-between
                        margin-bottom 15px
                    .echartSet_listbox
                        // padding 5px 10px
                        // overflow auto
                        display flex
                        margin-bottom 10px
                        .listbox_color
                            width 18px
                            height 18px
                            margin-right 15px
                            margin-top 3px
                            border-radius 5px
                            border 1px solid #a0a0a0
                            cursor pointer
                            user-select none
                        .listbox_text
                            flex 1
                            line-height 24px
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        .listbox_select
                            float right
                    .echartSet_listbox_map
                        margin-right: 5px;
                        margin-bottom: 8px;
                        display flex
                        justify-content space-between
                        .listbox_div
                            width 100%
                            .listbox_color
                                float right
                                width 18px
                                height 18px
                                margin-top 3px
                                margin-right 60px
                                border-radius 5px
                                border 1px solid #a0a0a0
                                cursor pointer
                                user-select none
                            .listbox_text
                                float left
                                line-height 24px
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap


                .echartSet_p_input
                    // overflow auto
                    &.map-style
                        .listbox_color
                            margin-right 0
                    padding-bottom 2px
                    margin-right 5px
                    margin-bottom 8px
                    display flex
                    justify-content space-between
                    flex-wrap wrap
                    align-items center
                    .echartSet_radioGroup
                        width 100%
                        display flex
                        justify-content space-between
                        color $right-view-content-textcolor
                    .echartSet_slider
                        padding-left 10px
                    .listbox_color
                        float left
                        width 18px
                        height 18px
                        margin-right 15px
                        margin-top 3px
                        border-radius 5px
                        border 1px solid #a0a0a0
                        cursor pointer
                        user-select none
                    > p
                        color $right-view-content-textcolor
                    .long_title
                        line-height 24px
                    .echartSet_checkbox
                        color $right-view-content-textcolor
                        height 24px
                    .echartSet_createTable
                        padding 0 15px
                        background-color #fff
                        border 1px solid $box-bordercolor
                        border-radius 3px
                        overflow auto
                        user-select none
                        cursor pointer
                        &:hover
                            background-color $main-hovercolor
                    .echartSet_increaseLine
                        position relative
                        margin-bottom 10px
                        color $right-view-content-textcolor
                        .item-ope
                            position: absolute
                            right 0
                            top 0
                            display inline-block
                            vertical-align top
                            height 20px
                            >svg
                                float left
                                width 20px
                                height 20px
                                &:hover
                                    background-color #e5e5e5
                                &:first-child
                                    margin-right 10px
                    .echartSet_increaseContent
                        margin-bottom 8px
                        .color_box
                            display inline-block
                            width 72px
                            height 24px
                            padding 5px
                            line-height 24px
                            vertical-align middle
                            margin-left 26px
                            background-color #fff
                            border 1px solid $box-bordercolor
                            border-radius 3px
                            .color
                                width 100%
                                height 100%

                .echartSet_line
                    display flex
                    justify-content space-between
                    >p
                        line-height 24px


    .excelEChart_container
        padding 10px 20px
        width 100%
        overflow auto
        .excelEChart_chartbox
            width 100%
            margin-top 15px
        .excelEChart_toolbox
            width 100%
            height 31px
            .excelEChart_importBtn
                float left
                min-width 64px
                padding 0 16px
                height 28px
                line-height 28px
                background-color var(--bg-color-primary)
                border 1px solid var(--border-color-propertyset-btn)
                box-shadow var(--box-shadow-color-small)
                border-radius 6px
                text-align center
                font-size 12px
                cursor pointer
                user-select none
                transition background-color .2s linear
                &:hover
                    background-color var(--bg-color-propertyset-btn-hover)
            .excelEChart_importList
                position absolute
                background-color var(--bg-color-tertiary)
                left 0
                top 32px
                border-radius 8px
                padding 6px
                box-shadow $box-shadow
                z-index 666
                overflow-x auto
                li
                    min-width 85px
                    height 32px
                    text-align left
                    line-height 32px
                    font-size 12px
                    color var(--text-color-excel-edit-data)
                    list-style none
                    box-sizing border-box
                    padding 0px 10px
                    white-space nowrap
                    border-radius 6px
                    &:hover
                        background-color var(--bg-color-box-hover-6)
                    &:first-child
                        border-top-right-radius 3px
                        border-top-left-radius 3px
                    &:last-child
                        border-bottom-right-radius 3px
                        border-bottom-left-radius 3px
            .excelEChart_import
                float left
                position relative
                margin-right 10px
            .excelEChart_output
                float left
                position relative


    .flex-reverse
        display flex
        flex-direction column-reverse
</style>

<template>
    <div>
        <div class="editEChart_maintitle" v-if="false">
            <p :class="{ active: !isEChartData, 'left-notactive': isEChartData }" @click="toggleTable(0)">{{ $t(chartAttrTitle) }}</p>
            <p :class="{ active: isEChartData, 'right-notactive': !isEChartData }" @click="toggleTable(1)">{{ $t(chartDataTitle) }}</p>
        </div>

        <div ref="changeTypeBox" class="echartSet_changeType" v-if="!isEChartData && !['gauge'].includes(chartType)">
            <div
                class="echartSet_changeBtn"
                :title="chartType == 'map' ? $t('refreshMap') : $t('EChartSet.content.changeType.title')"
                :class="{ active: isShowChangeBox }"
                @click="showChangeBox()"
            >
                {{ chartType == "map" ? $t("refreshMap") : $t("EChartSet.content.changeType.title") }}
            </div>
            <div class="echartSet_changeContent" v-show="isShowChangeBox">
                <div class="changeType-line" v-show="chartType == 'bar' || chartType == 'line' || chartType == 'bar&line'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.column") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('column', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-01.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('column', 1)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-02.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('column', 2)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-03.svg')})` }"
                        ></div>
                    </div>
                </div>
                <div class="changeType-line" v-show="chartType == 'bar' || chartType == 'line' || chartType == 'bar&line'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.bar") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('bar', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-04.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('bar', 1)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-05.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('bar', 2)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-06.svg')})` }"
                        ></div>
                    </div>
                </div>
                <div class="changeType-line" v-show="chartType == 'bar' || chartType == 'line' || chartType == 'bar&line'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.line") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('line', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-07.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('line', 1)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-08.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('line', 2)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-09.svg')})` }"
                        ></div>
                    </div>
                </div>
                <div class="changeType-line" v-show="chartType == 'bar' || chartType == 'line' || chartType == 'bar&line'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.fill") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('area', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-10.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('area', 1)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-11.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('area', 2)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-25.svg')})` }"
                        ></div>
                    </div>
                </div>
                <div class="changeType-line" v-show="chartType == 'scatter' || chartType == 'bubble'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.scatter") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('scatter', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-12.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('scatter', 1)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-13.svg')})` }"
                        ></div>
                    </div>
                </div>
                <div class="changeType-line" v-show="chartType == 'radar'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.radar") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('radar', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-14.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('radar', 1)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-15.svg')})` }"
                        ></div>
                    </div>
                    <div class="changeType-imgbox" @click="changeChartType('radar', 2)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-16.svg')})` }"
                        ></div>
                    </div>
                </div>
                <div class="changeType-line" v-show="chartType == 'pie' || chartType == 'funnel'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.pie") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('pie', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-17.svg')})` }"
                        ></div>
                    </div>
                    <!-- <div class="changeType-imgbox" @click="changeChartType('pie', 1)">
                        <div class="imgbox-svg" :style="{'background-Image': `url(${require('@/app/assets/img/right_echart/chart-18.svg')})`}"></div>
                    </div> -->
                    <div class="changeType-imgbox" @click="changeChartType('pie', 1)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-19.svg')})` }"
                        ></div>
                    </div>
                    <!-- <div class="changeType-imgbox" @click="changeChartType('pie', 3)">
                        <div class="imgbox-svg" :style="{'background-Image': `url(${require('@/app/assets/img/right_echart/chart-20.svg')})`}"></div>
                    </div> -->
                    <!-- <div class="changeType-imgbox" @click="changeChartType('pie', 2)">
                        <div class="imgbox-svg" :style="{'background-Image': `url(${require('@/app/assets/img/right_echart/chart-21.svg')})`}"></div>
                    </div> -->
                    <!-- <div class="changeType-imgbox" @click="changeChartType('pie', 5)">
                        <div class="imgbox-svg" :style="{'background-Image': `url(${require('@/app/assets/img/right_echart/chart-22.svg')})`}"></div>
                    </div> -->
                    <div class="changeType-imgbox" @click="changeChartType('pie', 2)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-24.svg')})` }"
                        ></div>
                    </div>
                </div>
                <div class="changeType-line" v-show="chartType == 'pie' || chartType == 'funnel'">
                    <p class="changeType-title">{{ $t("EChartSet.content.changeType.funnel") }}</p>
                    <div class="changeType-imgbox" @click="changeChartType('funnel', 0)">
                        <div
                            class="imgbox-svg"
                            :style="{ 'background-Image': `url(${require('@/app/assets/img/right_echart/chart-26.svg')})` }"
                        ></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="echartSet_container" v-if="!isEChartData">
            <div class="echartSet_box" v-if="chartType != 'map' && chartType != 'gauge'">
                <div class="editEChart_title" @click="toggleExpand('style')">
                    <p>{{ $t("EChartSet.content.chartStyle.title") }}</p>
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('style')">
                        <div class="echartSet_p_input">
                            <p class="long_title">{{ $t("EChartSet.content.chartStyle.legendPosition") }}</p>
                            <i-select
                                transfer
                                v-model="legend"
                                style="width: 80px"
                                size="small"
                                placement="bottom-end"
                                @on-change="setData('legend')"
                            >
                                <i-option value="hidden">{{ $t("EChartSet.content.chartStyle.legendPositionList.hidden") }}</i-option>
                                <i-option value="topCenter">{{ $t("EChartSet.content.chartStyle.legendPositionList.topCenter") }}</i-option>
                                <i-option value="topRight">{{ $t("EChartSet.content.chartStyle.legendPositionList.topRight") }}</i-option>
                                <i-option value="middleRight">{{ $t("EChartSet.content.chartStyle.legendPositionList.middleRight") }}</i-option>
                                <i-option value="bottomCenter">{{ $t("EChartSet.content.chartStyle.legendPositionList.bottomCenter") }}</i-option>
                                <i-option v-if="insideRadiusRatio > 0" value="middleCenter">
                                    {{ $t("EChartSet.content.chartStyle.legendPositionList.middleCenter") }}
                                </i-option>
                            </i-select>
                        </div>
                        <div class="echartSet_p_input" v-if="chartType == 'bar'">
                            <p class="long_title">{{ $t("EChartSet.content.chartStyle.seriesGap") }}</p>
                            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
                                <Slider
                                    class="echartSet_slider"
                                    v-model="seriesGap"
                                    size="small"
                                    :min="0"
                                    :max="100"
                                    :disabled="stackName || nameList.length <= 1"
                                    style="flex: 1; margin: 0 12px 0 0px"
                                    @on-change="setData('seriesGap')"
                                />
                                <InputNumber
                                    style="width: 80px"
                                    size="small"
                                    :max="100"
                                    :min="0"
                                    :precision="1"
                                    :disabled="stackName || nameList.length <= 1"
                                    :active-change="false"
                                    v-model="seriesGap"
                                    @on-change="setData('seriesGap')"
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                        </div>
                        <div class="echartSet_p_input" v-if="chartType == 'bar'">
                            <p class="long_title">{{ $t("EChartSet.content.chartStyle.categoryGap") }}</p>
                            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
                                <Slider
                                    class="echartSet_slider"
                                    v-model="categoryGap"
                                    size="small"
                                    :min="0"
                                    :max="100"
                                    @on-change="setData('categoryGap')"
                                    style="flex: 1; margin: 0 12px 0 0px"
                                />
                                <InputNumber
                                    style="width: 80px"
                                    size="small"
                                    :max="100"
                                    :min="0"
                                    :precision="1"
                                    :active-change="false"
                                    v-model="categoryGap"
                                    @on-change="setData('categoryGap')"
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                        </div>
                        <div class="echartSet_p_input" v-if="chartType == 'funnel'">
                            <p class="long_title">{{ $t("EChartSet.content.chartStyle.sort") }}</p>
                            <i-select v-model="funnelSort" style="width: 80px" size="small" placement="bottom-end" @on-change="setData('')">
                                <i-option value="none">{{ $t("EChartSet.content.chartStyle.sortList.none") }}</i-option>
                                <i-option value="ascending">{{ $t("EChartSet.content.chartStyle.sortList.ascending") }}</i-option>
                                <i-option value="descending">{{ $t("EChartSet.content.chartStyle.sortList.descending") }}</i-option>
                            </i-select>
                        </div>
                        <div class="echartSet_p_input" v-if="chartType == 'funnel'">
                            <p class="long_title">{{ $t("EChartSet.content.chartStyle.categoryGap") }}</p>
                            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
                                <Slider
                                    class="echartSet_slider"
                                    v-model="funnelGap"
                                    size="small"
                                    :min="0"
                                    :max="100"
                                    @on-change="setData('funnelGap')"
                                    style="flex: 1; margin: 0 12px 0 0px"
                                />
                                <InputNumber
                                    style="width: 80px"
                                    size="small"
                                    :max="100"
                                    :min="0"
                                    :precision="1"
                                    :active-change="false"
                                    v-model="funnelGap"
                                    @on-change="setData('funnelGap')"
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                        </div>
                    </div>
                </collapseTransition>
            </div>

            <div class="echartSet_box" v-if="chartType != 'map'">
                <div class="editEChart_title" @click="toggleExpand('setting')">
                    <p>{{ $t("EChartSet.content.seriesSetting.title") }}</p>
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('setting')">
                        <div class="echartSet_p_input" v-if="chartType != 'gauge'">
                            <p class="long_title">{{ $t("EChartSet.content.tagSetting.tagPostion") }}</p>

                            <i-select
                                v-model="seriesLabelPosition"
                                size="small"
                                placement="bottom-end"
                                style="width: 80px"
                                @on-change="setData('seriesLabelPosition')"
                            >
                                <i-option value="hidden">{{ $t("EChartSet.content.tagSetting.tagPostionList.hidden") }}</i-option>
                                <i-option v-if="chartType == 'pie'" value="outside">
                                    {{ $t("EChartSet.content.tagSetting.tagPostionList.outside") }}
                                </i-option>
                                <i-option v-if="orient == 'horizontal' && !stackName && chartType != 'funnel' && chartType != 'pie'" value="top">
                                    {{ $t("EChartSet.content.tagSetting.tagPostionList.top") }}
                                </i-option>
                                <i-option v-if="(orient == 'vertical' && !stackName) || chartType == 'funnel'" value="right">
                                    {{ $t("EChartSet.content.tagSetting.tagPostionList.right") }}
                                </i-option>
                                <i-option v-if="chartType == 'funnel'" value="left">
                                    {{ $t("EChartSet.content.tagSetting.tagPostionList.left") }}
                                </i-option>
                                <i-option value="inside">{{ $t("EChartSet.content.tagSetting.tagPostionList.inside") }}</i-option>
                                <i-option v-if="['line', 'scatter'].includes(chartType)" value="bottom">
                                    {{ $t("EChartSet.content.tagSetting.tagPostionList.bottom") }}
                                </i-option>
                            </i-select>
                        </div>
                        <div class="echartSet_p_input" v-if="chartType == 'gauge'">
                            <p class="long_title">{{ $t("EChartSet.content.tagSetting.tagShow") }}</p>
                            <i-switch v-model="labelVisible" @on-change="setData('')" />
                        </div>
                        <div v-if="['line', 'scatter', 'radar'].includes(chartType)">
                            <div class="echartSet_p_input" v-if="setBubbleMode !== 'bubble'">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.line.pointSize") }}</p>
                                <InputNumber
                                    style="width: 80px"
                                    :max="100"
                                    :min="1"
                                    size="small"
                                    v-model="symbolSize"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('symbolSize');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('symbolSize');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                        </div>
                        <div v-if="chartType == 'scatter' && setBubbleMode == 'bubble'">
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.scatter.bubbleMin") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    :min="1"
                                    :max="9007199254740992"
                                    v-model="BubbleMinSize"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.scatter.bubbleMax") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    :max="9007199254740992"
                                    v-model="BubbleMaxSize"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.scatter.min") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    v-model="minValue"
                                    :max="BubbleMinLimit"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.scatter.max") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    v-model="maxValue"
                                    :min="+BubbleMaxLimit"
                                    :max="9007199254740992"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('BubleRange');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                        </div>
                        <div v-if="chartType == 'scatter'">
                            <div class="echartSet_p_input">
                                <p>{{ $t("EChartSet.content.seriesSetting.scatter.scale") }}</p>
                                <i-switch style="margin-top: 5px" v-model="scale" @on-change="setData('')" />
                            </div>
                        </div>
                        <div v-if="chartType == 'funnel'">
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.scatter.min") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    v-model="funnelMin"
                                    :max="+funnelMinLimit"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.scatter.max") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    v-model="funnelMax"
                                    :min="+funnelMaxLimit"
                                    :max="9007199254740992"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.funnel.minSize") }}</p>
                                <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
                                    <Slider
                                        v-model="funnelMinSize"
                                        size="small"
                                        :min="0"
                                        :max="funnelMaxSize - 0.01"
                                        :step="0.01"
                                        @on-change="
                                            editLocker('edit', 'inputLocker', () => {
                                                setData('funnelMinSize');
                                            })
                                        "
                                        style="flex: 1; margin: 0 12px 0 8px"
                                    />
                                    <InputNumber
                                        size="small"
                                        style="width: 80px"
                                        :min="0"
                                        :formatter="(value) => `${Math.round(value * 100)}%`"
                                        :parser="(value) => value.replace('%', '') / 100"
                                        :max="funnelMaxSize"
                                        :step="0.01"
                                        v-model="funnelMinSize"
                                        :active-change="false"
                                        @on-focus="editLocker('focus', 'inputLocker')"
                                        @on-blur="
                                            editLocker('blur', 'inputLocker', () => {
                                                setData('funnelMinSize');
                                            })
                                        "
                                        @on-change="
                                            editLocker('edit', 'inputLocker', () => {
                                                setData('funnelMinSize');
                                            })
                                        "
                                        @keyup.enter.native="iviewInputBlur($event)"
                                    />
                                </div>
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.funnel.maxSize") }}</p>
                                <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
                                    <Slider
                                        v-model="funnelMaxSize"
                                        size="small"
                                        :min="funnelMinSize"
                                        :max="1"
                                        :step="0.01"
                                        @on-change="
                                            editLocker('edit', 'inputLocker', () => {
                                                setData('funnelMaxSize');
                                            })
                                        "
                                        style="flex: 1; margin: 0 12px 0 8px"
                                    />
                                    <InputNumber
                                        size="small"
                                        style="width: 80px"
                                        v-model="funnelMaxSize"
                                        :active-change="false"
                                        :step="0.01"
                                        :min="funnelMinSize"
                                        :max="1"
                                        :formatter="(value) => `${Math.round(value * 100)}%`"
                                        :parser="(value) => value.replace('%', '') / 100"
                                        @on-focus="editLocker('focus', 'inputLocker')"
                                        @on-blur="
                                            editLocker('blur', 'inputLocker', () => {
                                                setData('funnelMaxSize');
                                            })
                                        "
                                        @on-change="
                                            editLocker('edit', 'inputLocker', () => {
                                                setData('funnelMaxSize');
                                            })
                                        "
                                        @keyup.enter.native="iviewInputBlur($event)"
                                    />
                                </div>
                            </div>
                            <div class="echartSet_p_input">
                                <p>{{ $t("EChartSet.content.seriesSetting.pie.labelType") }}</p>
                                <i-select v-model="labelType" style="width: 80px" size="small" placement="bottom-end" @on-change="setData('')">
                                    <i-option :value="1">{{ $t("EChartSet.content.seriesSetting.pie.dataName") }}</i-option>
                                    <i-option :value="2">{{ $t("EChartSet.content.seriesSetting.pie.value") }}</i-option>
                                </i-select>
                            </div>
                            <div class="echartSet_p_input">
                                <p>{{ $t("EChartSet.content.seriesSetting.pie.percentLabel") }}</p>
                                <i-switch v-model="funnelPercent" @on-change="setData('')" />
                            </div>
                        </div>
                        <div v-if="chartType == 'pie'">
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.pie.insideRadiusRatio") }}</p>
                                <InputNumber
                                    style="width: 80px"
                                    size="small"
                                    :max="100"
                                    :min="0"
                                    :precision="1"
                                    :active-change="false"
                                    :formatter="(value) => `${value}%`"
                                    :parser="(value) => value.replace('%', '')"
                                    v-model="insideRadiusRatio"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('insideRadiusRatio');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('insideRadiusRatio');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.pie.rotateAngle") }}</p>
                                <div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
                                    <Slider
                                        v-model="pieRotate"
                                        size="small"
                                        :min="0"
                                        :max="360"
                                        @on-change="setData('startAngle')"
                                        style="flex: 1; margin: 0 12px 0 8px"
                                    />
                                    <InputNumber
                                        style="width: 80px"
                                        size="small"
                                        :max="360"
                                        :min="0"
                                        :precision="1"
                                        v-model="pieRotate"
                                        :active-change="false"
                                        @on-change="setData('startAngle')"
                                        @keyup.enter.native="iviewInputBlur($event)"
                                    />
                                </div>
                            </div>
                            <!-- <div class="echartSet_p_input">
                                <p class="long_title">{{$t('EChartSet.content.seriesSetting.pie.selectArea')}}</p>
                                <i-select v-model="colorListIndex" size="small" style="width:80px" >
                                    <i-option v-for="(item, index) in pieList" :value="index" :key="index">{{item.name}}</i-option>
                                </i-select>
                            </div>-->
                            <div class="echartSet_p_input">
                                <p>{{ $t("EChartSet.content.seriesSetting.pie.labelType") }}</p>
                                <i-select v-model="labelType" style="width: 80px" size="small" placement="bottom-end" @on-change="setData('')">
                                    <i-option :value="1">{{ $t("EChartSet.content.seriesSetting.pie.dataName") }}</i-option>
                                    <i-option :value="2">{{ $t("EChartSet.content.seriesSetting.pie.value") }}</i-option>
                                </i-select>
                            </div>
                            <div class="echartSet_p_input">
                                <p>{{ $t("EChartSet.content.seriesSetting.pie.percentLabel") }}</p>
                                <i-switch
                                    style="margin-top: 5px"
                                    :disabled="labelType == 1"
                                    v-model="percentLabel"
                                    @on-change="setData('percentLabel')"
                                />
                            </div>
                            <div class="echartSet_p_input" v-if="roseType != 'none'">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.pie.roseType") }}</p>
                                <i-select
                                    v-model="roseType"
                                    :disabled="roseType == 'none'"
                                    size="small"
                                    placement="bottom-end"
                                    style="width: 80px"
                                    @on-change="setData('roseType')"
                                >
                                    <i-option value="area">{{ $t("EChartSet.content.seriesSetting.pie.area") }}</i-option>
                                    <i-option value="radius">{{ $t("EChartSet.content.seriesSetting.pie.radius") }}</i-option>
                                </i-select>
                            </div>
                        </div>
                        <div v-if="chartType == 'gauge'">
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.gauge.gaugeMin") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    :min="0"
                                    :max="gaugeRangeMaxsize - 1"
                                    v-model="gaugeRangeMinsize"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('gaugeRange');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('gaugeRange');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.gauge.gaugeMax") }}</p>
                                <InputNumber
                                    size="small"
                                    style="width: 80px"
                                    :max="10000000000000"
                                    v-model="gaugeRangeMaxsize"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('gaugeRange');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('gaugeRange');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input">
                                <p>{{ $t("EChartSet.content.seriesSetting.gauge.gaugeColor") }}</p>
                                <ButtonGroup shape="circle" size="small">
                                    <Button @click="setData('gaugeSectorAdd')">+</Button>
                                    <Button @click="setData('gaugeSectorDel')">-</Button>
                                </ButtonGroup>
                            </div>
                            <div class="echartSet_p_input" v-for="(item, index) in gaugeRangeArr" :key="index">
                                <div class="listbox_color" :style="{ backgroundColor: item[1] }" @click="showColorBox($event, index, item[1])"></div>
                                <InputNumber
                                    :min="gaugeRangeMinsize"
                                    :max="9007199254740992"
                                    :disabled="index == gaugeRangeArr.length - 1"
                                    style="width: 80px"
                                    :precision="1"
                                    size="small"
                                    :formatter="(value) => `${value}`"
                                    v-model="item[0]"
                                    :active-change="false"
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="
                                        editLocker('blur', 'inputLocker', () => {
                                            setData('gaugeSector');
                                        })
                                    "
                                    @on-change="
                                        editLocker('edit', 'inputLocker', () => {
                                            setData('gaugeSector');
                                        })
                                    "
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                        </div>
                        <div v-if="chartType == 'line'">
                            <div class="echartSet_p_input">
                                <p class="long_title">{{ $t("EChartSet.content.seriesSetting.line.smoothLine") }}</p>
                                <i-switch v-model="smoothLine" @on-change="setData('smoothLine')" />
                            </div>
                        </div>
                    </div>
                </collapseTransition>
            </div>

            <div class="echartSet_box" v-if="chartType != 'gauge' && chartType != 'map'">
                <div class="editEChart_title" @click="toggleExpand('series')">
                    <p>{{ $t("EChartSet.content.tagSetting.title") }}</p>
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('series')">
                        <div
                            v-if="['line', 'bar', 'radar', 'bubble', 'scatter'].includes(chartType) && item != ''"
                            class="echartSet_listbox"
                            v-for="(item, index) in nameList"
                            :key="index"
                        >
                            <div
                                class="listbox_color"
                                :style="{ backgroundColor: colorList[index + 1] }"
                                @click="showColorBox($event, index + 1, colorList[index + 1])"
                            ></div>
                            <p class="listbox_text">{{ item }}</p>
                            <div class="listbox_select" v-if="false">
                                <div v-if="['line', 'bar', 'line&bar'].includes(chartType)">
                                    <div class="echartSet_p_input">
                                        <i-select
                                            v-model="seriesShapeType"
                                            size="small"
                                            placement="bottom-end"
                                            style="width: 80px"
                                            @on-change="setData('seriesShapeType')"
                                        >
                                            <i-option value="line">{{ $t("EChartSet.content.seriesSetting.bar.imgTypeLine") }}</i-option>
                                            <i-option value="bar">{{ $t("EChartSet.content.seriesSetting.bar.imgTypeBar") }}</i-option>
                                        </i-select>
                                    </div>
                                </div>
                            </div>
                            <div class="listbox_select" v-if="['line', 'scatter', 'radar'].includes(chartType)">
                                <i-select
                                    v-model="symbolTypeList[index + 1]"
                                    size="small"
                                    placement="bottom-end"
                                    style="width: 80px"
                                    @on-change="setData('symbolType', index + 1)"
                                >
                                    <i-option value="none">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.none") }}</i-option>
                                    <i-option value="emptyCircle">
                                        {{ $t("EChartSet.content.seriesSetting.line.pointShapeList.emptyCircle") }}
                                    </i-option>
                                    <i-option value="circle">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.circle") }}</i-option>
                                    <i-option value="rect">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.rect") }}</i-option>
                                    <i-option value="roundRect">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.roundRect") }}</i-option>
                                    <i-option value="triangle">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.triangle") }}</i-option>
                                    <i-option value="diamond">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.diamond") }}</i-option>
                                    <i-option value="pin">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.pin") }}</i-option>
                                    <i-option value="arrow">{{ $t("EChartSet.content.seriesSetting.line.pointShapeList.arrow") }}</i-option>
                                </i-select>
                            </div>
                        </div>

                        <div
                            v-if="chartType == 'pie' || chartType == 'funnel'"
                            class="echartSet_listbox"
                            v-for="(item, index) in pieList"
                            :key="index"
                        >
                            <div
                                class="listbox_color"
                                :style="{ backgroundColor: pieList[index].color }"
                                @click="showColorBox($event, index, pieList[index].color)"
                            ></div>
                            <p class="listbox_text">{{ pieList[index].name }}</p>
                            <div style="margin-right: 5px" v-if="chartType == 'pie'">
                                <i-switch style="margin-top: 5px" v-model="pieList[index].offset" @on-change="setData('offset')" />
                            </div>
                        </div>
                    </div>
                </collapseTransition>
            </div>

            <div class="echartSet_box" v-if="coordinateType == 'grid' || coordinateType == 'radar'">
                <div class="editEChart_title" @click="toggleExpand('coordinate')">
                    <p>
                        {{
                            coordinateType == "radar"
                                ? $t("EChartSet.content.coordinate.radarTitle")
                                : $t("EChartSet.content.coordinate.cartesianTitle")
                        }}
                    </p>
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('coordinate')">
                        <div class="echartSet_p_input" v-if="coordinateType == 'grid'">
                            <p class="listbox_text">{{ $t("EChartSet.content.coordinate.lineColor") }}</p>
                            <div
                                class="listbox_color"
                                :style="{ backgroundColor: coordinateColor }"
                                @click="showColorBox($event, 666, coordinateColor)"
                            ></div>
                        </div>
                        <div class="echartSet_p_input" v-if="coordinateType == 'grid'">
                            <RadioGroup class="echartSet_radioGroup" v-model="coordinateRadio" @on-change="setData('changeCoordinateType')">
                                <Radio :label="0">{{ $t("EChartSet.content.coordinate.x") }}</Radio>
                                <Radio :label="1">{{ $t("EChartSet.content.coordinate.y") }}</Radio>
                            </RadioGroup>
                        </div>
                        <div class="echartSet_p_input" v-if="coordinateType == 'grid'">
                            <p class="long_title">{{ $t("EChartSet.content.coordinate.name") }}</p>
                            <Input v-model="coordinateName" @on-blur="changeCoordinateName()" size="small" style="width: 80px" />
                        </div>
                        <div class="echartSet_p_input echartSet_line" v-if="coordinateType == 'grid'">
                            <p>{{ $t("EChartSet.content.coordinate.namePosition") }}</p>
                            <i-select v-model="coordinatePosition" style="width: 80px" size="small" placement="bottom-end" @on-change="setData('')">
                                <i-option value="middle">{{ $t("EChartSet.content.coordinate.shaft") }}</i-option>
                                <i-option value="end">{{ $t("EChartSet.content.coordinate.shaftTail") }}</i-option>
                            </i-select>
                        </div>
                        <div
                            class="echartSet_p_input echartSet_line"
                            v-if="coordinateType == 'grid' && coordinateData[coordinateRadio].type == 'value'"
                        >
                            <p>{{ $t("EChartSet.content.coordinate.max") }}</p>
                            <InputNumber
                                style="width: 80px"
                                :min="+maxLimit"
                                :max="9007199254740992"
                                size="small"
                                :step="hasPercent ? 0.1 : 1"
                                :precision="1"
                                v-model="coordinateMax"
                                :active-change="false"
                                @on-focus="editLocker('focus', 'inputLocker')"
                                @on-blur="
                                    editLocker('blur', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @on-change="
                                    editLocker('edit', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                        </div>
                        <div
                            class="echartSet_p_input echartSet_line"
                            v-if="coordinateType == 'grid' && coordinateData[coordinateRadio].type == 'value'"
                        >
                            <p>{{ $t("EChartSet.content.coordinate.min") }}</p>
                            <InputNumber
                                style="width: 80px"
                                :max="minLimit"
                                size="small"
                                :step="hasPercent ? 0.1 : 1"
                                :precision="1"
                                v-model="coordinateMin"
                                :active-change="false"
                                @on-focus="editLocker('focus', 'inputLocker')"
                                @on-blur="
                                    editLocker('blur', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @on-change="
                                    editLocker('edit', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                        </div>
                        <div
                            class="echartSet_p_input echartSet_line"
                            v-if="coordinateType == 'radar' || (coordinateType == 'grid' && coordinateData[coordinateRadio].type == 'value')"
                        >
                            <p>{{ $t("EChartSet.content.coordinate.segments") }}</p>
                            <InputNumber
                                style="width: 80px"
                                :max="100"
                                :min="1"
                                size="small"
                                v-model="coordinateSegment"
                                :active-change="false"
                                @on-focus="editLocker('focus', 'inputLocker')"
                                @on-blur="
                                    editLocker('blur', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @on-change="
                                    editLocker('edit', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                        </div>

                        <div class="echartSet_p_input echartSet_line" v-if="chartType == 'radar'">
                            <p>{{ $t("EChartSet.content.coordinate.shape") }}</p>
                            <i-select v-model="coordinateShape" style="width: 80px" size="small" placement="bottom-end" @on-change="setData('')">
                                <i-option value="polygon">{{ $t("EChartSet.content.coordinate.polygon") }}</i-option>
                                <i-option value="circle">{{ $t("EChartSet.content.coordinate.circular") }}</i-option>
                            </i-select>
                        </div>

                        <div class="echartSet_p_input echartSet_line">
                            <Checkbox class="echartSet_checkbox" v-model="coordinateShowSplit">
                                {{ $t("EChartSet.content.coordinate.showSplit") }}
                            </Checkbox>
                        </div>
                        <div class="echartSet_p_input echartSet_line">
                            <Checkbox class="echartSet_checkbox" v-model="coordinateShowScale">
                                {{
                                    coordinateType == "radar"
                                        ? $t("EChartSet.content.coordinate.showAxisLine")
                                        : $t("EChartSet.content.coordinate.showScale")
                                }}
                            </Checkbox>
                        </div>
                    </div>
                </collapseTransition>
            </div>

            <div class="echartSet_box" v-if="chartType != 'map' && chartType != 'scatter'">
                <div class="editEChart_title" @click="toggleExpand('dataFormat')">
                    <p>{{ $t("EChartSet.content.dataFormat.title") }}</p>
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('dataFormat')">
                        <div class="echartSet_p_input echartSet_line">
                            <p>{{ $t("EChartSet.content.dataFormat.title") }}</p>
                            <i-select v-model="dataFormat" style="width: 80px" size="small" placement="bottom-end" @on-change="setData('')">
                                <i-option :value="0">{{ $t("EChartSet.content.dataFormat.normal") }}</i-option>
                                <i-option :value="1">{{ $t("EChartSet.content.dataFormat.delimiter") }}</i-option>
                                <i-option :value="2">{{ $t("EChartSet.content.dataFormat.abbreviation") }}</i-option>
                            </i-select>
                        </div>
                        <div class="echartSet_p_input echartSet_line">
                            <p>{{ $t("EChartSet.content.dataFormat.accuracy") }}</p>
                            <i-select v-model="dataFormatAccuracy" style="width: 80px" size="small" placement="bottom-end" @on-change="setData('')">
                                <i-option :value="3">{{ $t("EChartSet.content.dataFormat.percentileThousand") }}</i-option>
                                <i-option :value="2">{{ $t("EChartSet.content.dataFormat.percentage") }}</i-option>
                                <template v-if="!hasPercent">
                                    <i-option :value="1">{{ $t("EChartSet.content.dataFormat.digit") }}</i-option>
                                    <i-option :value="0">{{ $t("EChartSet.content.dataFormat.bit") }}</i-option>
                                    <template v-if="dataFormat != 2">
                                        <i-option :value="-1">{{ $t("EChartSet.content.dataFormat.decade") }}</i-option>
                                        <i-option :value="-2">{{ $t("EChartSet.content.dataFormat.hundred") }}</i-option>
                                    </template>
                                </template>
                            </i-select>
                        </div>
                        <div class="echartSet_p_input">
                            <Checkbox class="echartSet_checkbox" :disabled="!hasPercent" v-model="dataFormatPercent">
                                {{ $t("EChartSet.content.dataFormat.percent") }}
                            </Checkbox>
                        </div>
                        <div class="echartSet_p_input">
                            <Checkbox
                                class="echartSet_checkbox"
                                :disabled="chartType == 'pie' || chartType == 'radar' || chartType == 'funnel'"
                                v-model="axisPrefixSuffix"
                            >
                                {{ $t("EChartSet.content.dataFormat.axisPrefixSuffix") }}
                            </Checkbox>
                        </div>
                        <div class="echartSet_p_input">
                            <Checkbox class="echartSet_checkbox" v-model="valuePrefixSuffix">
                                {{ $t("EChartSet.content.dataFormat.valuePrefixSuffix") }}
                            </Checkbox>
                        </div>
                        <div class="echartSet_p_input echartSet_line">
                            <p>{{ $t("EChartSet.content.dataFormat.preUnit") }}</p>
                            <Input
                                v-model="dataFormatPreUnit"
                                size="small"
                                style="width: 80px"
                                :disabled="!axisPrefixSuffix && !valuePrefixSuffix"
                                @on-focus="editLocker('focus', 'inputLocker')"
                                @on-blur="
                                    editLocker(
                                        'blur',
                                        'inputLocker',
                                        () => {
                                            setData('');
                                        },
                                        0
                                    )
                                "
                                @on-change="
                                    editLocker('edit', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                        </div>
                        <div class="echartSet_p_input echartSet_line">
                            <p>{{ $t("EChartSet.content.dataFormat.sufUnit") }}</p>
                            <Input
                                v-model="dataFormatSufUnit"
                                size="small"
                                style="width: 80px"
                                :disabled="!axisPrefixSuffix && !valuePrefixSuffix"
                                @on-focus="editLocker('focus', 'inputLocker')"
                                @on-blur="
                                    editLocker(
                                        'blur',
                                        'inputLocker',
                                        () => {
                                            setData('');
                                        },
                                        1
                                    )
                                "
                                @on-change="
                                    editLocker('edit', 'inputLocker', () => {
                                        setData('');
                                    })
                                "
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                        </div>
                    </div>
                </collapseTransition>
            </div>

            <div class="echartSet_box" v-if="chartType == 'map'">
                <div class="editEChart_title" @click="toggleExpand('mapStyle')">
                    <p>{{ $t("EChartSet.content.mapStyle.title") }}</p>
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('mapStyle')">
                        <div class="map-style">
                            <p class="listbox_text">{{ $t("EChartSet.content.mapStyle.backgroundColor") }}</p>
                            <div
                                class="listbox_color"
                                :style="{ backgroundColor: mapBackground }"
                                @click="showColorBox($event, 1, mapBackground)"
                            ></div>
                        </div>
                    </div>
                </collapseTransition>
            </div>
            <div class="echartSet_box" v-if="chartType == 'map'">
                <div class="editEChart_title" @click="toggleExpand('colorMapping')">
                    <p>{{ $t("EChartSet.content.colorMapping.title") }}</p>
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('colorMapping')">
                        <!-- <div class="echartSet_p_input">
                            <span class="echartSet_createTable">{{ $t('EChartSet.content.colorMapping.createTable') }}</span>
                        </div> -->
                        <!-- <div class="echartSet_p_input echartSet_line">
                            <p>{{ $t('EChartSet.content.colorMapping.type') }}</p>
                            <i-select v-model="colorMappingType" style="width:40%" size="small" @on-change="setData('')">
                                <i-option :value="0">{{$t('EChartSet.content.colorMapping.subsection')}}</i-option>
                                <i-option :value="1">{{$t('EChartSet.content.colorMapping.continuity')}}</i-option>
                            </i-select>
                        </div> -->
                        <div class="echartSet_p_input echartSet_line">
                            <p>{{ $t("EChartSet.content.colorMapping.max") }}</p>
                            <InputNumber
                                style="width: 80px"
                                :min="visualMapMaxLimit || visualMapMin"
                                :max="1e16"
                                size="small"
                                v-model="visualMapMax"
                                :disabled="!visualMap"
                                @on-change="setData('')"
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                        </div>
                        <div class="echartSet_p_input echartSet_line">
                            <p>{{ $t("EChartSet.content.colorMapping.min") }}</p>
                            <InputNumber
                                style="width: 80px"
                                :max="visualMapMinLimit || visualMapMax"
                                :min="-1e16"
                                size="small"
                                :disabled="!visualMap"
                                v-model="visualMapMin"
                                @on-change="setData('')"
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                        </div>
                        <div class="echartSet_p_input">
                            <RadioGroup class="echartSet_radioGroup" :disabled="!visualMap" v-model="mapColorType">
                                <Radio :disabled="!visualMap" label="continuous">{{ $t("continuous") }}</Radio>
                                <Radio :disabled="!visualMap" label="piecewise">{{ $t("piecewise") }}</Radio>
                            </RadioGroup>
                        </div>
                        <div v-show="mapColorType == 'continuous'">
                            <div class="echartSet_listbox_map">
                                <div class="listbox_div">
                                    <p class="listbox_text">{{ $t("EChartSet.content.colorMapping.higher") }}</p>
                                    <div
                                        class="listbox_color"
                                        :style="{ backgroundColor: visualMapHightColor }"
                                        @click="showColorBox($event, 2, visualMapHightColor)"
                                    ></div>
                                </div>
                            </div>
                            <div class="echartSet_listbox_map">
                                <div class="listbox_div">
                                    <p class="listbox_text">{{ $t("EChartSet.content.colorMapping.lower") }}</p>
                                    <div
                                        class="listbox_color"
                                        :style="{ backgroundColor: visualMapLowColor }"
                                        @click="showColorBox($event, 3, visualMapLowColor)"
                                    ></div>
                                </div>
                            </div>
                            <!-- <div class="echartSet_p_input">
                                <div class="echartSet_increaseLine">
                                    <p>{{ $t('EChartSet.content.colorMapping.increase')}}</p>
                                    <div class='item-ope'>
                                        <iconSymbol @click.native='addSlider' :name="'Add'" />
                                        <iconSymbol @click.native='delSlider' :name="'Delete'" />
                                    </div>
                                </div>
                                <div class="echartSet_increaseContent" v-for="item in 10">
                                    <InputNumber
                                    style="width: 55%"
                                    :precision="1"
                                    size="small"
                                    :formatter="value => `${value}`"
                                    v-model="item[0]" 
                                    @on-focus="editLocker('focus', 'inputLocker')"
                                    @on-blur="editLocker('blur', 'inputLocker', ()=>{setData('')})"
                                    @on-change="editLocker('edit', 'inputLocker', ()=>{setData('')})"/>
                                    <div class="color_box"  @click="showColorBox($event, index)">
                                        <div class="color" :style="{backgroundColor: item}"></div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="echartSet_p_input echartSet_line">
                                <p>{{ $t("EChartSet.content.colorMapping.width") }}</p>
                                <InputNumber
                                    style="width: 80px"
                                    :min="1"
                                    :max="200"
                                    size="small"
                                    :disabled="!visualMap"
                                    v-model="visualMapWidth"
                                    @on-change="setData('')"
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <div class="echartSet_p_input echartSet_line">
                                <p>{{ $t("EChartSet.content.colorMapping.height") }}</p>
                                <InputNumber
                                    style="width: 80px"
                                    :min="2"
                                    :max="200"
                                    size="small"
                                    :disabled="!visualMap"
                                    v-model="visualMapHeight"
                                    @on-change="setData('')"
                                    @keyup.enter.native="iviewInputBlur($event)"
                                />
                            </div>
                            <!-- <div class="echartSet_p_input echartSet_line">
                                <p>{{ $t('EChartSet.content.colorMapping.position') }}</p>
                                <i-select v-model="colorMappingPosition" style="width:40%" size="small" @on-change="setData('')">
                                    <i-option :value="0">123</i-option>
                                </i-select>
                            </div> -->
                        </div>
                        <div v-show="mapColorType == 'piecewise'">
                            <div class="echartSet_p_input">
                                <p>{{ $t("EChartSet.content.seriesSetting.gauge.gaugeColor") }}</p>
                                <ButtonGroup shape="circle" size="small">
                                    <Button @click="setData('mapColorDataAdd')">+</Button>
                                    <Button @click="setData('mapColorDataDel')">-</Button>
                                </ButtonGroup>
                            </div>
                            <div class="flex-reverse">
                                <div class="echartSet_p_input" v-for="(item, index) in mapColorData" :key="index">
                                    <div
                                        class="listbox_color"
                                        :style="{ backgroundColor: item[1] }"
                                        @click="showColorBox($event, index + 500, item[1])"
                                    ></div>
                                    <InputNumber
                                        :max="9007199254740992"
                                        :disabled="index == 0"
                                        style="width: 80px"
                                        :precision="1"
                                        size="small"
                                        :formatter="(value) => `${value}`"
                                        v-model="item[0]"
                                        :active-change="false"
                                        @on-focus="editLocker('focus', 'inputLocker')"
                                        @on-blur="
                                            editLocker('blur', 'inputLocker', () => {
                                                setData('mapColorData');
                                            })
                                        "
                                        @on-change="
                                            editLocker('edit', 'inputLocker', () => {
                                                setData('mapColorData');
                                            })
                                        "
                                        @keyup.enter.native="iviewInputBlur($event)"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="echartSet_p_input">
                            <RadioGroup class="echartSet_radioGroup" :disabled="!visualMap" v-model="visualMapOrient" @on-change="setData('')">
                                <Radio :disabled="!visualMap" label="horizontal">{{ $t("EChartSet.content.colorMapping.H") }}</Radio>
                                <Radio :disabled="!visualMap" label="vertical">{{ $t("EChartSet.content.colorMapping.V") }}</Radio>
                                <Radio :disabled="!visualMap" label="invisible">{{ $t("EChartSet.content.colorMapping.none") }}</Radio>
                            </RadioGroup>
                        </div>
                        <div class="echartSet_p_input map-style">
                            <p class="listbox_text">{{ $t("EChartSet.content.mapStyle.lineColor") }}</p>
                            <div
                                class="listbox_color"
                                :style="{ backgroundColor: mapLineColor }"
                                @click="showColorBox($event, 4, mapLineColor)"
                            ></div>
                        </div>
                    </div>
                </collapseTransition>
            </div>

            <div class="echartSet_box bottomNone" v-if="chartType == 'map'">
                <div class="editEChart_title map-region">
                    <p>{{ $t("EChartSet.content.mapRegion.showName") }}</p>
                    <i-switch v-model="regionSwitch" @click.native.stop @on-change="() => setRegionShow('switchAll')" />
                </div>
                <collapseTransition>
                    <div class="echartSet_content" v-show="expandList.includes('mapRegion')">
                        <div class="region-checkbox" v-for="(item, idx) in regionData" :key="idx" v-if="idx <= 9">
                            <p class="region-name">{{ item.name }}</p>
                            <Checkbox v-model="item.label.show" @on-change="setRegionShow" />
                        </div>
                        <div class="region_changeBtn" @click="openRegion">
                            {{ $t("EChartSet.content.mapRegion.more") }}
                        </div>
                    </div>
                </collapseTransition>
            </div>
        </div>

        <div class="excelEChart_container" v-show="isEChartData">
            <div class="excelEChart_toolbox">
                <div class="excelEChart_import" v-click-outside="closeOutsideImport">
                    <div class="excelEChart_importBtn" @click="excelFile(0)">{{ $t("EChartSet.content.tableData.import") }}</div>
                    <!-- <div class="excelEChart_importBtn" @click="importShow = importShow ? false : true">{{$t('EChartSet.content.tableData.import')}}</div>
                    <ul class="excelEChart_importList" v-show="importShow">
                        <li @click="excelFile(0)">{{$t('EChartSet.content.tableData.localImport')}}</li>
                    </ul> -->
                </div>
                <div class="excelEChart_output" v-click-outside="closeOutsideOutput">
                    <div class="excelEChart_importBtn" @click="outputShow = outputShow ? false : true">
                        {{ $t("EChartSet.content.tableData.output") }}
                    </div>
                    <ul class="excelEChart_importList" v-show="outputShow">
                        <li @click="excelFile(1)">{{ $t("EChartSet.content.tableData.outputExcel") }}</li>
                        <li @click="excelFile(2)">{{ $t("EChartSet.content.tableData.outputcsv") }}</li>
                    </ul>
                </div>
            </div>
            <div class="excelEChart_chartbox">
                <ExcelTable ref="exceltable" :chartData="chartData"></ExcelTable>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import ExcelTable from "../../../EChart/ExcelTable.vue";
    import collapseTransition from "@/public/utils/collapse-transition.js";
    import { chartData } from "@/app/components/FloatTool/echart/chartData";

    @Component({
        components: {
            ExcelTable,
            collapseTransition,
        },
    })
    export default class EChartSet extends Vue {
        @Inject()
        ["iviewInputBlur"];

        excelURL: string = "";
        isShowChangeBox: boolean = false;
        importShow: boolean = false;
        outputShow: boolean = false;
        inputLocker: boolean = false;
        regionSwitch: boolean = true;
        expandList: Array<string> = ["style", "setting", "series", "coordinate", "dataFormat", "radarCoordinate", "colorMapping", "mapRegion"];

        hexify(color) {
            // rgba => #ffffff
            if (/^#/.test(color) || color == "") return color;
            var values = color
                .replace(/rgba?\(/, "")
                .replace(/\)/, "")
                .replace(/[\s+]/g, "")
                .split(",");
            var a = parseFloat(values[3] || 1),
                r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
                g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
                b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
            return "#" + ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
        }
        get colorIndex() {
            return this.$store.state.echart.colorIndex;
        }
        set colorIndex(v) {
            this.$store.commit("setEChartState", {
                type: "colorIndex",
                data: v,
            });
        }
        showColorBox(e, id, color) {
            this.colorIndex = id;
            let payload = {
                type: this.fmtType.echart,
                index: this.colorIndex,
            };
            this.$store.commit("setEChartState", {
                type: "activeSeriesColor",
                data: color,
            });
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "123" });
            });
        }
        toggleExpand(name) {
            if (this.expandList.includes(name)) {
                for (let i = 0; i < this.expandList.length; i++) {
                    if (this.expandList[i] == name) {
                        this.expandList.splice(i, 1);
                        break;
                    }
                }
            } else {
                this.expandList.push(name);
            }
            this.$store.commit("setEChartState", { type: "expandList", data: this.expandList });
        }
        changeCoordinateName() {
            let _view = window["_view"];
            if (this.coordinateRadio == 0) {
                _view.processChartCMD("axisName", { index: "x", data: this.coordinateName });
            } else {
                _view.processChartCMD("axisName", { index: "y", data: this.coordinateName });
            }
        }
        editLocker(type, lock, fn?, t?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        if (t === 0) {
                            let _view = window["_view"];
                            _view.processChartCMD("prefix", { data: this.dataFormatPreUnit });
                        } else if (t === 1) {
                            let _view = window["_view"];
                            _view.processChartCMD("suffix", { data: this.dataFormatSufUnit });
                        }
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        changeChartType(type, index) {
            this.isShowChangeBox = false;
            if (this.chartType == "gauge") return;
            window.removeEventListener("click", this.closeChangeBox);
            window["_view"].processChartCMD("changeChartType", { data: type, index: index });
        }
        showChangeBox() {
            if (this.chartType == "map") {
                let _view = window["_view"];
                _view.processChartCMD("refreshMapData", {});
                this.setData(" ");
                return;
            }
            if (this.isShowChangeBox) {
                this.isShowChangeBox = false;
                window.removeEventListener("click", this.closeChangeBox);
            } else {
                this.$track("rightPanel", "chart", "change type");
                this.isShowChangeBox = true;
                window.addEventListener("click", this.closeChangeBox);
            }
        }
        closeChangeBox(e) {
            let objTarget = this.$refs["changeTypeBox"] as HTMLElement;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.isShowChangeBox = false;
                window.removeEventListener("click", this.closeChangeBox);
            }
        }
        setRegionShow(type) {
            type === "switchAll" && this.toggleExpand("mapRegion");
            if (type === "switchAll" && !this.regionSwitch) {
                let data = this.regionData.map((item) => ({
                    ...item,
                    label: {
                        show: false,
                        color: "#444",
                    },
                }));
                window["_view"].processChartCMD("mapRegionData", { data });
            } else {
                window["_view"].processChartCMD("mapRegionData", { data: this.regionData });
            }
        }

        openRegion() {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "showName",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }

        excelFile(type) {
            // 导入导出
            switch (type) {
                case 0: {
                    this.importShow = false;
                    (this.$refs.exceltable as any).importExcelClick();
                    break;
                }
                case 1: {
                    this.outputShow = false;
                    (this.$refs.exceltable as any).exportExcel();
                    break;
                }
                case 2: {
                    this.outputShow = false;
                    (this.$refs.exceltable as any).exportCsv();
                    break;
                }
            }
        }
        closeOutsideImport() {
            this.importShow = false;
        }
        closeOutsideOutput() {
            this.outputShow = false;
        }
        toggleTable(num) {
            // 打开修改数据弹窗
            this.isEChartData = num == 0 ? false : true;
            this.$store.commit("updateEChart", { isInit: true }); // 重新获取数据
            this.$nextTick(() => {
                window["_view"].onsize();
            });
        }
        setData(type, index?) {
            this.$track("rightPanel", "chart", type);
            console.log(type);
            if (["seriesGap", "startAngle", "categoryGap", "funnelGap", "funnelMinSize", "funnelMaxSize"].includes(type)) {
                // slider 特殊处理
                setTimeout(() => {
                    this.$store.commit("setEChart", type);
                }, 0);
            } else {
                if (type == "symbolType") {
                    // 设置当前选中的序列
                    this.$store.commit("setEChartState", { type: "index", data: index });
                }
                this.$store.commit("setEChart", type);
            }
        }

        get chartAttrTitle() {
            return this.chartType == "map" ? "mapAttrTitle" : "normalAttrTitle";
        }
        get chartDataTitle() {
            return this.chartType == "map" ? "mapDataTitle" : "normalDataTitle";
        }
        get visualMap() {
            return this.$store.state.echart.visualMap;
        }
        get visualMapHeight() {
            return this.$store.state.echart.visualMapHeight;
        }
        get visualMapHightColor() {
            return this.$store.state.echart.visualMapHightColor;
        }
        get visualMapHightText() {
            return this.$store.state.echart.visualMapHightText;
        }
        get visualMapLowColor() {
            return this.$store.state.echart.visualMapLowColor;
        }
        get visualMapLowText() {
            return this.$store.state.echart.visualMapLowText;
        }
        get visualMapMax() {
            return this.$store.state.echart.visualMapMax;
        }
        get visualMapMaxLimit() {
            return this.$store.state.echart.visualMapMaxLimit;
        }
        get visualMapMin() {
            return this.$store.state.echart.visualMapMin;
        }
        get visualMapMinLimit() {
            return this.$store.state.echart.visualMapMinLimit;
        }
        get visualMapOrient() {
            return this.$store.state.echart.visualMapOrient;
        }
        get visualMapWidth() {
            return this.$store.state.echart.visualMapWidth;
        }

        get showDataFlag() {
            return this.$store.state.echart.showDataFlag;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get typeList() {
            return this.$store.state.echart.typeList.filter((v) => {
                return v != "";
            });
        }
        get colorList() {
            return this.$store.state.echart.chartDataColor.map((v, k) => {
                return this.hexify(v);
            });
        }
        get nameList() {
            return this.$store.state.echart.serieslist.filter((v) => {
                return v != null;
            });
        }
        get changeColor() {
            return this.$store.state.echart.changeColor;
        }
        get styleHeight() {
            if (!this.expandList.includes("style")) {
                return "height: 30px";
            } else {
                return this.chartType != "bar" ? "height: auto" : "height: 220px";
            }
        }
        get coordinateHeight() {
            if (!this.expandList.includes("coordinate")) {
                return "height: 30px";
            } else {
                return this.chartType == "radar" ? "height: 160px" : "height: 310px";
            }
        }
        get settingHeight() {
            if (!this.expandList.includes("setting")) {
                return "height: 30px";
            }
            let type = this.chartType;
            switch (type) {
                case "bar": {
                    return "height: auto";
                }
                case "line": {
                    return "height: auto";
                }
                case "scatter": {
                    if (this.$store.state.echart.setBubbleMode == "bubble") return "height: auto";
                    else return "height: auto";
                }
                case "radar": {
                    return "height: auto";
                }
                case "gauge": {
                    let length = this.$store.state.echart.gaugeRangeArr.length;
                    return `height: auto`;
                }
                case "pie": {
                    return "height: auto";
                }
            }
        }
        get legend() {
            return this.$store.state.echart.legend;
        }
        get insideRadiusRatio() {
            return this.$store.state.echart.insideRadiusRatio;
        }
        get chartType() {
            return this.$store.state.echart.chartType;
        }
        get seriesGap() {
            return this.$store.state.echart.seriesGap;
        }
        get categoryGap() {
            return this.$store.state.echart.categoryGap;
        }
        get currentSeries() {
            return this.$store.state.echart.currentSeries;
        }
        get seriesShapeType() {
            return this.$store.state.echart.seriesShapeType;
        }
        get symbolType() {
            return this.$store.state.echart.symbolType;
        }
        get symbolTypeList() {
            return this.$store.state.echart.symbolTypeList;
        }
        get setBubbleMode() {
            return this.$store.state.echart.setBubbleMode;
        }
        get symbolSize() {
            return this.$store.state.echart.symbolSize;
        }
        get BubbleMinSize() {
            return this.$store.state.echart.BubbleMinSize;
        }
        get BubbleMaxSize() {
            return this.$store.state.echart.BubbleMaxSize;
        }
        get minValue() {
            return this.$store.state.echart.minValue;
        }
        get maxValue() {
            return this.$store.state.echart.maxValue;
        }
        get minLimit() {
            return this.$store.state.echart.minLimit;
        }
        get maxLimit() {
            return this.$store.state.echart.maxLimit;
        }
        get hasPercent() {
            return this.$store.state.echart.hasPercent;
        }
        get isPercent() {
            return this.$store.state.echart.isPercent;
        }
        get percentLabel() {
            return this.$store.state.echart.percentLabel;
        }
        get roseType() {
            return this.$store.state.echart.roseType;
        }
        get pieRotate() {
            return this.$store.state.echart.pieRotate;
        }
        get colorListIndex() {
            return this.$store.state.echart.colorListIndex;
        }
        get pieList() {
            return this.$store.state.echart.pieList;
        }
        get gaugeRangeMaxsize() {
            return this.$store.state.echart.gaugeRangeMaxsize;
        }
        get gaugeRangeMinsize() {
            return this.$store.state.echart.gaugeRangeMinsize;
        }
        get gaugeRangeArr() {
            return this.$store.state.echart.gaugeRangeArr;
        }
        get seriesLabelPosition() {
            return this.$store.state.echart.seriesLabelPosition;
        }
        get orient() {
            return this.$store.state.echart.orient;
        }
        get shapeType() {
            return this.$store.state.shape.type;
        }
        get chartData() {
            if (this.shapeType == "EChartItem") {
                return this.newEchartList;
            }
            return this.$store.state.echart.chartData;
        }
        get regionData() {
            return this.$store.state.echart.mapRegionData;
        }
        set regionData(newVal) {
            this.$store.commit("setEChartState", {
                type: "mapRegionData",
                data: newVal,
            });
        }
        get BubbleMinLimit() {
            return this.$store.state.echart.BubbleMinLimit;
        }
        get coordinateRadio() {
            return this.$store.state.echart.coordinateRadio;
        }
        get coordinateName() {
            return this.$store.state.echart.coordinateName;
        }
        get coordinatePosition() {
            return this.$store.state.echart.coordinatePosition;
        }
        get coordinateMax() {
            return this.$store.state.echart.coordinateMax;
        }
        get coordinateMin() {
            return this.$store.state.echart.coordinateMin;
        }
        get coordinateSegment() {
            return this.$store.state.echart.coordinateSegment;
        }
        get coordinateShape() {
            return this.$store.state.echart.coordinateShape;
        }
        get coordinateShowSplit() {
            return this.$store.state.echart.coordinateShowSplit;
        }
        get coordinateShowScale() {
            return this.$store.state.echart.coordinateShowScale;
        }
        get dataFormat() {
            return this.$store.state.echart.dataFormat;
        }
        get dataFormatAccuracy() {
            return this.$store.state.echart.dataFormatAccuracy;
        }
        get dataFormatPercent() {
            return this.$store.state.echart.dataFormatPercent;
        }
        get axisPrefixSuffix() {
            return this.$store.state.echart.axisPrefixSuffix;
        }
        get valuePrefixSuffix() {
            return this.$store.state.echart.valuePrefixSuffix;
        }
        get dataFormatPreUnit() {
            return this.$store.state.echart.dataFormatPreUnit;
        }
        get dataFormatSufUnit() {
            return this.$store.state.echart.dataFormatSufUnit;
        }
        get colorMappingType() {
            return this.$store.state.echart.colorMappingType;
        }
        get colorMappingMax() {
            return this.$store.state.echart.colorMappingMax;
        }
        get colorMappingMin() {
            return this.$store.state.echart.colorMappingMin;
        }
        get colorMappingWidth() {
            return this.$store.state.echart.colorMappingWidth;
        }
        get colorMappingHeight() {
            return this.$store.state.echart.colorMappingHeight;
        }
        get colorMappingRadio() {
            return this.$store.state.echart.colorMappingRadio;
        }
        get colorMappingPosition() {
            return this.$store.state.echart.colorMappingPosition;
        }
        get coordinateType() {
            return this.$store.state.echart.coordinateType;
        }
        get coordinateData() {
            return this.$store.state.echart.coordinateData;
        }
        get BubbleMaxLimit() {
            return this.$store.state.echart.BubbleMaxLimit;
        }
        get stackName() {
            return this.$store.state.echart.stackName;
        }
        get showAxisLine() {
            return this.$store.state.echart.showAxisLine;
        }
        get labelVisible() {
            return this.$store.state.echart.labelVisible;
        }
        get funnelGap() {
            return this.$store.state.echart.funnelGap;
        }
        get funnelMax() {
            return this.$store.state.echart.funnelMax;
        }
        get funnelMaxLimit() {
            return this.$store.state.echart.funnelMaxLimit;
        }
        get funnelMaxSize() {
            return this.$store.state.echart.funnelMaxSize;
        }
        get funnelMin() {
            return this.$store.state.echart.funnelMin;
        }
        get funnelMinLimit() {
            return this.$store.state.echart.funnelMinLimit;
        }
        get funnelMinSize() {
            return this.$store.state.echart.funnelMinSize;
        }
        get funnelSort() {
            return this.$store.state.echart.funnelSort;
        }
        get funnelPercent() {
            return this.$store.state.echart.funnelPercent;
        }

        get scale() {
            return !(this.$store.state.echart.scale_x && this.$store.state.echart.scale_y);
        }

        get labelType() {
            return this.$store.state.echart.labelType;
        }

        get mapBackground() {
            return this.$store.state.echart.mapBackground;
        }
        get mapLineColor() {
            return this.$store.state.echart.mapLineColor;
        }
        get smoothLine() {
            return this.$store.state.echart.smoothLine;
        }

        set labelType(v) {
            this.$store.commit("setEChartState", {
                type: "labelType",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("seriesLabelType", { data: v });
        }

        set scale(v) {
            this.$store.commit("setEChartState", {
                type: "scale_x",
                data: v,
            });
            this.$store.commit("setEChartState", {
                type: "scale_y",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("originLock", { data: v });
            // _view.processChartCMD('axisScale',{index: 'x', data: !v})
            // _view.processChartCMD('axisScale',{index: 'y', data: !v})
        }

        set funnelGap(v) {
            this.$store.commit("setEChartState", {
                type: "funnelGap",
                data: v,
            });
        }
        set funnelMax(v) {
            this.$store.commit("setEChartState", {
                type: "funnelMax",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("funnelMax", { data: v });
        }

        set funnelMaxSize(v) {
            this.$store.commit("setEChartState", {
                type: "funnelMaxSize",
                data: v,
            });
            // let _view = window['_view']
            // _view.processChartCMD('funnelMaxSize',{data: v})
        }
        set funnelMin(v) {
            this.$store.commit("setEChartState", {
                type: "funnelMin",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("funnelMin", { data: v });
        }
        set funnelMinSize(v) {
            this.$store.commit("setEChartState", {
                type: "funnelMinSize",
                data: v,
            });
            // let _view = window['_view']
            // _view.processChartCMD('funnelMinSize',{data: v})
        }
        set funnelSort(v) {
            this.$store.commit("setEChartState", {
                type: "funnelSort",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("funnelSort", { data: v });
        }
        set funnelPercent(v) {
            this.$store.commit("setEChartState", {
                type: "funnelPercent",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("percentLabel", { data: v });
        }

        set visualMapHeight(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapHeight",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapHeight", { data: v });
        }
        set visualMapHightColor(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapHightColor",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapHightColor", { data: v });
        }
        set visualMapHightText(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapHightText",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapHeightText", { data: v });
        }
        set visualMapLowColor(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapLowColor",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapLowColor", { data: v });
        }
        set visualMapLowText(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapLowText",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapLowText", { data: v });
        }
        set visualMapMax(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapMax",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapMax", { data: v });
        }
        set visualMapMin(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapMin",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapMin", { data: v });
        }
        set visualMapOrient(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapOrient",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapStatus", { data: v });
        }
        set visualMapWidth(v) {
            this.$store.commit("setEChartState", {
                type: "visualMapWidth",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapWidth", { data: v });
        }

        set legend(v) {
            this.$store.commit("setEChartState", {
                type: "legend",
                data: v,
            });
        }
        set insideRadiusRatio(v) {
            this.$store.commit("setEChartState", {
                type: "insideRadiusRatio",
                data: v,
            });
        }
        set chartType(v) {
            this.$store.commit("setEChartState", {
                type: "chartType",
                data: v,
            });
        }
        set seriesGap(v) {
            this.$store.commit("setEChartState", {
                type: "seriesGap",
                data: v,
            });
        }
        set categoryGap(v) {
            this.$store.commit("setEChartState", {
                type: "categoryGap",
                data: v,
            });
        }
        set currentSeries(v) {
            this.$store.commit("setEChartState", {
                type: "currentSeries",
                data: v,
            });
        }
        set seriesShapeType(v) {
            this.$store.commit("setEChartState", {
                type: "seriesShapeType",
                data: v,
            });
        }
        set symbolType(v) {
            this.$store.commit("setEChartState", {
                type: "symbolType",
                data: v,
            });
        }
        set symbolTypeList(v) {
            this.$store.commit("setEChartState", {
                type: "symbolType",
                data: v,
            });
        }
        set setBubbleMode(v) {
            this.$store.commit("setEChartState", {
                type: "setBubbleMode",
                data: v,
            });
        }
        set symbolSize(v) {
            this.$store.commit("setEChartState", {
                type: "symbolSize",
                data: v,
            });
        }
        set BubbleMinSize(v) {
            this.$store.commit("setEChartState", {
                type: "BubbleMinSize",
                data: v,
            });
        }
        set BubbleMaxSize(v) {
            this.$store.commit("setEChartState", {
                type: "BubbleMaxSize",
                data: v,
            });
        }
        set minValue(v) {
            this.$store.commit("setEChartState", {
                type: "minValue",
                data: v,
            });
        }
        set maxValue(v) {
            this.$store.commit("setEChartState", {
                type: "maxValue",
                data: v,
            });
        }
        set percentLabel(v) {
            this.$store.commit("setEChartState", {
                type: "percentLabel",
                data: v,
            });
        }
        set roseType(v) {
            this.$store.commit("setEChartState", {
                type: "roseType",
                data: v,
            });
        }
        set pieRotate(v) {
            this.$store.commit("setEChartState", {
                type: "pieRotate",
                data: v,
            });
        }
        set colorListIndex(v) {
            this.$store.commit("setEChartState", {
                type: "colorListIndex",
                data: v,
            });
        }
        set pieList(v) {
            this.$store.commit("setEChartState", {
                type: "pieList",
                data: v,
            });
        }
        set gaugeRangeMaxsize(v) {
            if (v <= this.gaugeRangeMinsize) v = this.gaugeRangeMinsize + 1;
            this.$store.commit("setEChartState", {
                type: "gaugeRangeMaxsize",
                data: v,
            });
        }
        set gaugeRangeMinsize(v) {
            if (v >= this.gaugeRangeMaxsize) v = this.gaugeRangeMaxsize - 1;
            this.$store.commit("setEChartState", {
                type: "gaugeRangeMinsize",
                data: v,
            });
        }
        set gaugeRangeArr(v) {
            this.$store.commit("setEChartState", {
                type: "gaugeRangeArr",
                data: v,
            });
        }
        set seriesLabelPosition(v) {
            this.$store.commit("setEChartState", {
                type: "seriesLabelPosition",
                data: v,
            });
        }
        set orient(v) {
            this.$store.commit("setEChartState", {
                type: "orient",
                data: v,
            });
        }
        set chartData(v) {
            this.$store.commit("setEChartState", {
                type: "chartData",
                data: v,
            });
        }
        set coordinateRadio(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateRadio",
                data: v,
            });
        }
        set coordinateName(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateName",
                data: v,
            });
        }
        set coordinatePosition(v) {
            this.$store.commit("setEChartState", {
                type: "coordinatePosition",
                data: v,
            });
            let _view = window["_view"];
            if (this.coordinateRadio == 0) {
                _view.processChartCMD("axisNamePos", { index: "x", data: v });
            } else {
                _view.processChartCMD("axisNamePos", { index: "y", data: v });
            }
        }
        set coordinateMax(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateMax",
                data: v,
            });
            console.log(v, "======================");
            let _view = window["_view"];
            if (this.coordinateRadio == 0) {
                _view.processChartCMD("dimMax", { index: "x", data: v });
            } else {
                _view.processChartCMD("dimMax", { index: "y", data: v });
            }
        }
        set coordinateMin(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateMin",
                data: v,
            });
            let _view = window["_view"];
            if (this.coordinateRadio == 0) {
                _view.processChartCMD("dimMin", { index: "x", data: v });
            } else {
                _view.processChartCMD("dimMin", { index: "y", data: v });
            }
        }
        set coordinateSegment(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateSegment",
                data: v,
            });
            let _view = window["_view"];
            if (this.coordinateRadio == 0) {
                _view.processChartCMD("dimSplitNumber", { index: "x", data: v });
            } else {
                _view.processChartCMD("dimSplitNumber", { index: "y", data: v });
            }
        }
        set coordinateShape(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateShape",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("radarShape", { data: v });
        }
        set coordinateShowSplit(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateShowSplit",
                data: v,
            });
            let _view = window["_view"];
            if (this.coordinateRadio == 0) {
                _view.processChartCMD("showSplitLine", { index: "x", data: v });
            } else {
                _view.processChartCMD("showSplitLine", { index: "y", data: v });
            }
        }
        set coordinateShowScale(v) {
            this.$store.commit("setEChartState", {
                type: "coordinateShowScale",
                data: v,
            });
            let _view = window["_view"];
            let cmd = "showTick";
            if (this.coordinateType == "radar") cmd = "showAxisLine";
            if (this.coordinateRadio == 0) {
                _view.processChartCMD(cmd, { index: "x", data: v });
            } else {
                _view.processChartCMD(cmd, { index: "y", data: v });
            }
        }
        set showAxisLine(v) {
            this.$store.commit("setEChartState", {
                type: "showAxisLine",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("showAxisLine", { index: "x", data: v });
        }
        set dataFormat(v) {
            this.$store.commit("setEChartState", {
                type: "dataFormat",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("NumFormat", { data: v });
        }
        set dataFormatAccuracy(v) {
            this.$store.commit("setEChartState", {
                type: "dataFormatAccuracy",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("dataPrecision", { data: v });
        }
        set dataFormatPercent(v) {
            this.$store.commit("setEChartState", {
                type: "dataFormatPercent",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("Percent", { data: v });
        }
        set axisPrefixSuffix(v) {
            this.$store.commit("setEChartState", {
                type: "axisPrefixSuffix",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("axisPrefixSuffix", { data: v });
        }
        set valuePrefixSuffix(v) {
            this.$store.commit("setEChartState", {
                type: "valuePrefixSuffix",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("valuePrefixSuffix", { data: v });
        }
        set dataFormatPreUnit(v) {
            this.$store.commit("setEChartState", {
                type: "dataFormatPreUnit",
                data: v,
            });
            // let _view = window['_view']
            // _view.processChartCMD('prefix',{data: v})
        }
        set dataFormatSufUnit(v) {
            this.$store.commit("setEChartState", {
                type: "dataFormatSufUnit",
                data: v,
            });
            // let _view = window['_view']
            // _view.processChartCMD('suffix',{data: v})
        }
        set colorMappingType(v) {
            this.$store.commit("setEChartState", {
                type: "colorMappingType",
                data: v,
            });
        }
        set colorMappingMax(v) {
            this.$store.commit("setEChartState", {
                type: "colorMappingMax",
                data: v,
            });
        }
        set colorMappingMin(v) {
            this.$store.commit("setEChartState", {
                type: "colorMappingMin",
                data: v,
            });
        }
        set colorMappingWidth(v) {
            this.$store.commit("setEChartState", {
                type: "colorMappingWidth",
                data: v,
            });
        }
        set colorMappingHeight(v) {
            this.$store.commit("setEChartState", {
                type: "colorMappingHeight",
                data: v,
            });
        }
        set colorMappingRadio(v) {
            this.$store.commit("setEChartState", {
                type: "colorMappingRadio",
                data: v,
            });
        }
        set colorMappingPosition(v) {
            this.$store.commit("setEChartState", {
                type: "colorMappingPosition",
                data: v,
            });
        }
        set labelVisible(v) {
            this.$store.commit("setEChartState", {
                type: "labelVisible",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("labelVisible", { data: v, index: 0 });
        }
        set smoothLine(v) {
            this.$store.commit("setEChartState", {
                type: "smoothLine",
                data: v,
            });
        }

        get isEChartData() {
            return this.$store.state.ui.isEChartData;
        }
        set isEChartData(v) {
            this.$store.commit("setStatus", {
                type: "isEChartData",
                data: v,
            });
        }
        get coordinateColor() {
            return this.hexify(this.$store.state.echart.coordinateColor);
        }
        get mapColorType() {
            return this.$store.state.echart.mapColorType;
        }
        set mapColorType(v) {
            this.$store.commit("setEChartState", {
                type: "mapColorType",
                data: v,
            });
            let _view = window["_view"];
            _view.processChartCMD("visualMapType", { data: v });
            this.showChangeBox();
        }
        get mapColorData() {
            return this.$store.state.echart.mapColorData;
        }
        set mapColorData(v) {
            this.$store.commit("setEChartState", {
                type: "mapColorType",
                data: v,
            });
        }

        @Watch("changeColor")
        watchChangeColor(newval: any, oldVal: any) {
            if (this.isEChartData) return;
            if (newval !== "") {
                let temp = JSON.parse(JSON.stringify(this.colorList));
                temp.splice(this.colorIndex, 1, newval);
                this.$store.commit("setEChartState", { type: "chartDataColor", data: temp });
            }
        }

        get chartOption() {
            return this.$store.state.newEchart.activeChartOption;
        }
        get activeChartType() {
            return this.$store.state.newEchart.activeChartType;
        }
        newEchartList = [];
        initData() {
            if (this.shapeType == "EChartItem") {
                chartData.loadOption(this.chartOption, this.activeChartType);
                this.newEchartList = chartData.initDataSet();
            }
        }
        reloadData() {
            if (this.activeChartType == "funnel") {
                this.initData();
            }
        }

        beforeDestroy() {
            window.removeEventListener("click", this.closeChangeBox);
            this.$bus.$off("updateEchartData", this.reloadData);
        }
        mounted() {
            console.log(this.$store.state.echart, "init");
            this.expandList = [...this.$store.state.echart.expandList];
            this.$bus.$on("excelFile", (index) => {
                this.excelFile(index);
            });
            if (this.shapeType == "EChartItem") {
                this.initData();
                this.$bus.$on("updateEchartData", this.reloadData);
            }
        }

        created() {}
        activated() {
            this.$bus.$emit("setRightViewTitle", "chartSet");
            this.initData();
        }
    }
</script>
<i18n>
{
  "zh": {
    "mapAttrTitle": "地图属性",
    "mapDataTitle": "地图数据",
    "normalAttrTitle": "图表属性",
    "normalDataTitle": "图表数据",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "改变类型",
          "column": "柱状图",
          "bar": "条形图",
          "line": "折线图",
          "fill": "面积图",
          "scatter": "散点图",
          "radar": "雷达图",
          "pie": "饼图",
          "funnel": "漏斗图"
        },
        "chartStyle": {
          "title": "图表样式",
          "legendPosition": "图例位置",
          "legendPositionList": {
            "hidden": "隐藏",
            "topCenter": "顶部中间",
            "topRight": "右侧顶部",
            "middleRight": "右侧中间",
            "bottomCenter": "底部中间",
            "middleCenter": "居中"
          },
          "sort": "排序",
          "sortList": {
            "none": "无",
            "ascending": "正序",
            "descending": "逆序"
          },
          "seriesGap": "序列间距",
          "categoryGap": "分类间距"
        },
        "mapStyle": {
          "title": "地图样式",
          "backgroundColor": "背景颜色",
          "lineColor": "轮廓线颜色"
        },
        "mapRegion": {
          "showName": "显示地区名称",
          "more": "更多"
        },
        "seriesSetting": {
          "title": "序列设置",
          "bar": {
            "imgTypeLine": "线型图",
            "imgTypeBar": "柱状图"
          },
          "line": {
            "pointShape": "拐点形状",
            "pointShapeList": {
              "emptyCircle": "空心圆",
              "circle": "圆形",
              "rect": "矩形",
              "roundRect": "圆角矩形",
              "triangle": "三角形",
              "diamond": "菱形",
              "pin": "图钉",
              "arrow": "箭头",
              "none": "无"
            },
            "pointSize": "拐点大小",
            "smoothLine": "平滑曲线"
          },
          "scatter": {
            "bubbleMax": "气泡最大值",
            "bubbleMin": "气泡最小值",
            "max": "最大值",
            "min": "最小值",
            "scale": "原点锁定"
          },
          "funnel": {
            "minSize": "最小宽度",
            "maxSize": "最大宽度"
          },
          "pie": {
            "insideRadiusRatio": "内径比值",
            "rotateAngle": "旋转角度",
            "selectArea": "选择区域",
            "ispop": "是否弹出",
            "percentLabel": "百分比显示",
            "roseType": "玫瑰图类型",
            "area": "面积",
            "radius": "半径",
            "labelType": "序列标签类型",
            "dataName": "分类",
            "value": "数据"
          },
          "gauge": {
            "gaugeMin": "仪表下限",
            "gaugeMax": "仪表上限",
            "gaugeColor": "仪表盘颜色"
          }
        },
        "tagSetting": {
          "title": "图例设置",
          "tagPostion": "标签位置",
          "tagShow": "显示标签",
          "tagPostionList": {
            "hidden": "隐藏",
            "outside": "外侧",
            "right": "右侧",
            "left": "左侧",
            "top": "顶部",
            "inside": "内部",
            "bottom": "底部"
          }
        },
        "tableData": {
          "import": "导入",
          "localImport": "本地导入",
          "output": "导出",
          "outputExcel": "导出XLSX",
          "outputcsv": "导出CSV"
        },
        "coordinate": {
          "lineColor": "坐标颜色",
          "cartesianTitle": "二维直角坐标系",
          "radarTitle": "雷达图坐标系",
          "x": "X坐标轴",
          "y": "Y坐标轴",
          "name": "名称",
          "namePosition": "名称位置",
          "shaft": "轴中",
          "shaftTail": "轴尾",
          "max": "上限",
          "min": "下限",
          "segments": "分段数量",
          "showSplit": "显示分割线",
          "showScale": "显示刻度",
          "showAxisLine": "显示轴线",
          "shape": "坐标系形状",
          "polygon": "多边形",
          "circular": "圆"
        },
        "dataFormat": {
          "title": "数据格式",
          "normal": "普通",
          "delimiter": "分隔符",
          "abbreviation": "缩写",
          "accuracy": "精度",
          "percentileThousand": "千分位",
          "percentage": "百分位",
          "digit": "十分位",
          "bit": "个位",
          "decade": "十位",
          "hundred": "百位",
          "percent": "百分号",
          "axisPrefixSuffix": "轴标签前/后缀",
          "valuePrefixSuffix": "数据标签前/后缀",
          "preUnit": "前缀单位",
          "sufUnit": "后缀单位"
        },
        "colorMapping": {
          "title": "颜色设置",
          "createTable": "生成映射表",
          "type": "类型",
          "subsection": "分段",
          "continuity": "连续",
          "max": "上限",
          "min": "下限",
          "increase": "递增分段",
          "width": "颜色条宽度",
          "height": "颜色条高度",
          "H": "横向",
          "V": "纵向",
          "none": "隐藏",
          "position": "位置",
          "higher": "上限颜色",
          "lower": "下限颜色"
        }
      }
    },
    "continuous": "连续颜色",
    "piecewise": "分段颜色",
    "refreshMap": "刷新数据"
  },
  "en": {
    "mapAttrTitle": "Properties",
    "mapDataTitle": "Data",
    "normalAttrTitle": "Properties",
    "normalDataTitle": "Data",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "Change Chart Type",
          "column": "Column",
          "bar": "Bar",
          "line": "Line",
          "fill": "Area",
          "scatter": "Scatter",
          "radar": "Spider and Radar",
          "pie": "Pie",
          "funnel": "Funnel"
        },
        "chartStyle": {
          "title": "Chart Style",
          "legendPosition": "Legend Position",
          "legendPositionList": {
            "hidden": "Hide",
            "topCenter": "Top Center",
            "topRight": "Top Right",
            "middleRight": "Middle Right",
            "bottomCenter": "Bottom Center",
            "middleCenter": "Middle Center"
          },
          "sort": "Sequence",
          "sortList": {
            "none": "None",
            "ascending": "Ascending Sequence",
            "descending": "Descending Sequence"
          },
          "seriesGap": "Series Gap",
          "categoryGap": "Category Gap"
        },
        "mapStyle": {
          "title": "Map Style",
          "backgroundColor": "Background",
          "lineColor": "Border Color"
        },
        "mapRegion": {
          "showName": "Show Region Name",
          "more": "More..."
        },
        "seriesSetting": {
          "title": "Series Settings ",
          "bar": {
            "imgTypeLine": "Line",
            "imgTypeBar": "Bar "
          },
          "line": {
            "pointShape": "Point Shape ",
            "pointShapeList": {
              "emptyCircle": "Empty Circle",
              "circle": "Circle",
              "rect": "Rectangle",
              "roundRect": "RoundRect",
              "triangle": "Triangle",
              "diamond": "Diamond",
              "pin": "Pin",
              "arrow": "Arrow",
              "none": "None"
            },
            "pointSize": "Inflection Point Size",
            "smoothLine": "Smooth Line"
          },
          "scatter": {
            "bubbleMax": "Bubble Maxi",
            "bubbleMin": "Bubble Min",
            "max": "Maximum",
            "min": "Minimum",
            "scale": "Scatter diagram"
          },
          "funnel": {
            "minSize": "Minimum Width",
            "maxSize": "Maximum Width"
          },
          "pie": {
            "insideRadiusRatio": "Inside Diameter Ratio",
            "rotateAngle": "Rotate Angle",
            "selectArea": "Select Area",
            "ispop": "Is it popping?",
            "percentLabel": "Percent Label",
            "roseType": "Rose Chart Type",
            "area": "Area",
            "radius": "Radius",
            "labelType": "Label Type",
            "dataName": "Classification",
            "value": "Value"
          },
          "gauge": {
            "gaugeMin": "Min Scale",
            "gaugeMax": "Max Scale",
            "gaugeColor": "Gauge Color"
          }
        },
        "tagSetting": {
          "title": "Tag Property",
          "tagPostion": "Tag Position",
          "tagShow": "Show Tag",
          "tagPostionList": {
            "hidden": "Hide",
            "outside": "Outside",
            "right": "Right",
            "left": "Left",
            "top": "Top",
            "inside": "Inside",
            "bottom": "bottom"
          }
        },
        "tableData": {
          "import": "Import",
          "localImport": "Import from Local Device",
          "output": "Export",
          "outputExcel": "Export XLSX",
          "outputcsv": "Export CSV"
        },
        "coordinate": {
          "lineColor": "Coordinate Color",
          "cartesianTitle": "Cartesian Coordinate System",
          "radarTitle": "Radar Coordinate System",
          "x": "X Axis",
          "y": "Y Axis",
          "name": "Name",
          "namePosition": "Name Position",
          "shaft": "In the Middle of Axis",
          "shaftTail": "Axis Tail",
          "max": "Maximum",
          "min": "Minimum",
          "segments": "Number of Segments",
          "showSplit": "Show Split",
          "showScale": "Show Scale",
          "showAxisLine": "Show AxisLine",
          "shape": "Coordinate Shape",
          "polygon": "Polygon",
          "circular": "Circular"
        },
        "dataFormat": {
          "title": "Data Format",
          "normal": "Normal",
          "delimiter": "Delimiter",
          "abbreviation": "Abbreviation",
          "accuracy": "Accuracy",
          "percentileThousand": "Thousandths",
          "percentage": "Hundredths",
          "digit": "Tenths",
          "bit": "Ones",
          "decade": "Tens",
          "hundred": "Hundreds",
          "percent": "Percent Sign",
          "axisPrefixSuffix": "Axis Label Prefix/Suffix",
          "valuePrefixSuffix": "Data Label Prefix/Suffix",
          "preUnit": "Prefix Unit",
          "sufUnit": "Suffix Unit"
        },
        "colorMapping": {
          "title": "Color Mapping",
          "createTable": "Generate Mapping Table",
          "type": "Type",
          "subsection": "Subsection",
          "continuity": "Continuity",
          "max": "Maximum",
          "min": "Minumum",
          "increase": "Increasing Subsection",
          "width": "Width",
          "height": "Height",
          "H": "Horizontal",
          "V": "Vertical",
          "none": "Hide",
          "position": "Position",
          "higher": "Higher Position",
          "lower": "Lower Position"
        }
      }
    },
    "continuous": "Continuous",
    "piecewise": "Segmented",
    "refreshMap": "Refresh Data"
  },
  "fr": {
    "mapAttrTitle": "Propriétés du graphique",
    "mapDataTitle": "Données du graphique",
    "normalAttrTitle": "Propriétés du graphique",
    "normalDataTitle": "Données du graphique",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "Changer le type",
          "column": "Histogramme",
          "bar": "Graphique à barres",
          "line": "Graphique linéaire",
          "fill": "Graphique de zone",
          "scatter": "Nuage de points",
          "radar": "Diagramme de Kiviat",
          "pie": "Diagramme circulaire",
          "funnel": "Graphique en entonnoir"
        },
        "chartStyle": {
          "title": "Style de graphique",
          "legendPosition": "Position de la légende",
          "legendPositionList": {
            "hidden": "Caché",
            "topCenter": "Centre Supérieur",
            "topRight": "En haut à droite",
            "middleRight": "Milieu Droit",
            "bottomCenter": "En bas au centre",
            "middleCenter": "Centre du milieu"
          },
          "sort": "Trier",
          "sortList": {
            "none": "Nul",
            "ascending": "Séquence positive",
            "descending": "Ordre inverse"
          },
          "seriesGap": "Espacement des séquences",
          "categoryGap": "Espacement de classification"
        },
        "mapStyle": {
          "title": "Style de carte",
          "backgroundColor": "Couleur de fond",
          "lineColor": "couleur de ligne"
        },
        "mapRegion": {
          "showName": "afficher le nom",
          "more": "Plus"
        },
        "seriesSetting": {
          "title": "Paramètres de séquence",
          "bar": {
            "imgTypeLine": "Linéaire",
            "imgTypeBar": "Columnar"
          },
          "line": {
            "pointShape": "Forme du point d'inflexion",
            "pointShapeList": {
              "emptyCircle": "Cercle vide",
              "circle": "Cercle",
              "rect": "rect",
              "roundRect": "Rectangle arrondi",
              "triangle": "Triangle",
              "diamond": "diamant",
              "pin": "épingle",
              "arrow": "Flèche",
              "none": "nul"
            },
            "pointSize": "Taille du point d'inflexion",
            "smoothLine": "Courbe lisse"
          },
          "scatter": {
            "bubbleMax": "Bulle maximum",
            "bubbleMin": "Bulle minimum",
            "max": "Max",
            "min": "Min",
            "scale": "Verrouiller l'origine"
          },
          "funnel": {
            "minSize": "Largeur minimale",
            "maxSize": "Largeur maximale"
          },
          "pie": {
            "insideRadiusRatio": "Rapport du diamètre intérieur",
            "rotateAngle": "Angle de rotation",
            "selectArea": "Sélectionnez une zone",
            "ispop": "Sont pop-up",
            "percentLabel": "Affichage du pourcentage",
            "roseType": "Type de graphique rose",
            "area": "Zone",
            "radius": "Rayon",
            "labelType": "Type de graphique rose",
            "dataName": "Catégorie",
            "value": "Données"
          },
          "gauge": {
            "gaugeMin": "Jauge Min",
            "gaugeMax": "Jauge Max",
            "gaugeColor": "Couleur de Jauge "
          }
        },
        "tagSetting": {
          "title": "Paramètres de légende",
          "tagPostion": "Position de l'étiquette",
          "tagShow": "Afficher l'étiquette",
          "tagPostionList": {
            "hidden": "Caché",
            "outside": "à l'extérieur",
            "right": "Droit",
            "left": "Gauche",
            "top": "Haut",
            "inside": "à l'intérieur",
            "bottom": "bas"
          }
        },
        "tableData": {
          "import": "Importer",
          "localImport": "Importation locale",
          "output": "Exporter",
          "outputExcel": "Exporter XLSX",
          "outputcsv": "Exporter CSV"
        },
        "coordinate": {
          "lineColor": "Couleur de coordonner",
          "cartesianTitle": "Système de coordonnées rectangulaires bidimensionnel",
          "radarTitle": "Système de coordonnées Kiviat",
          "x": "Axe des coordonnées X",
          "y": "Axe des coordonnées Y",
          "name": "Nom",
          "namePosition": "Emplacement du nom",
          "shaft": "milieu d'axe",
          "shaftTail": "queue d 'axe",
          "max": "Max",
          "min": "Min",
          "segments": "Nombre de segments",
          "showSplit": "Afficher la ligne de séparation",
          "showScale": "Afficher l'échelle",
          "showAxisLine": "Afficher l'axe",
          "shape": "Forme du système de coordonnées",
          "polygon": "Polygone",
          "circular": "Circulaire"
        },
        "dataFormat": {
          "title": "Format des données",
          "normal": "Ordinaire",
          "delimiter": "Délimiteur",
          "abbreviation": "Abréviation",
          "accuracy": "Précision",
          "percentileThousand": "millième",
          "percentage": "Centile",
          "digit": "Décile",
          "bit": "Bit",
          "decade": "Dix",
          "hundred": "Cent",
          "percent": "Signe de pourcentage",
          "axisPrefixSuffix": "pré / suffixe d'étiquette d'axe",
          "valuePrefixSuffix": "pré / suffixe d'étiquette de données",
          "preUnit": "unité prefix",
          "sufUnit": "Unité suffixe"
        },
        "colorMapping": {
          "title": "couleur cartographie",
          "createTable": "Générer une table de mappage",
          "type": "Tapez",
          "subsection": "Segmentation",
          "continuity": "Continu",
          "max": "max",
          "min": "min",
          "increase": "Segment incrémental",
          "width": "largeur",
          "height": "haut",
          "H": "Horizontal",
          "V": "vertical",
          "none": "Cacher",
          "position": "Emplacement",
          "higher": "Élevé",
          "lower": "faible"
        }
      }
    },
    "continuous": "Couleur continue",
    "piecewise": "Couleur du segment",
    "refreshMap": "Actualiser les données"
  },
  "de": {
    "mapAttrTitle": "Eigenschaften",
    "mapDataTitle": "Daten",
    "normalAttrTitle": "Eigenschaften",
    "normalDataTitle": "Daten",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "Diagrammtyp wechseln",
          "column": "Säulendiagramm",
          "bar": "Balkendiagramm",
          "line": "Tedenzdiaramm",
          "fill": "Flächendiagramm",
          "scatter": "Streudiagramm",
          "radar": "Radardiagramm",
          "pie": "Kreisdiagramm",
          "funnel": "Tunneldiagramm"
        },
        "chartStyle": {
          "title": "Diagrammstil",
          "legendPosition": "Legendenposition",
          "legendPositionList": {
            "hidden": "Verbergen",
            "topCenter": "Oben in der Mitte ",
            "topRight": "Oben rechts",
            "middleRight": "Mitte rechts",
            "bottomCenter": "Mitte unten",
            "middleCenter": "Zentral Mitte"
          },
          "sort": "Reihenfolge",
          "sortList": {
            "none": "Nimand",
            "ascending": "Aufsteigende Reihenfolge",
            "descending": "Absteigende Reihenfolge"
          },
          "seriesGap": "Lücke im Verlauf",
          "categoryGap": "Lücke in der Kategorie"
        },
        "mapStyle": {
          "title": "Kartenstil",
          "backgroundColor": "Hintergrundsfarbe",
          "lineColor": "Konturfarbe"
        },
        "mapRegion": {
          "showName": "Bezirksname anzeigen",
          "more": "Mehr "
        },
        "seriesSetting": {
          "title": "Serieneinstellungen",
          "bar": {
            "imgTypeLine": "Linie",
            "imgTypeBar": "Leiste"
          },
          "line": {
            "pointShape": "Punktform",
            "pointShapeList": {
              "emptyCircle": "Leerer Kreis",
              "circle": "Kreis",
              "rect": "Rechteck",
              "roundRect": "Rundes Rechteck",
              "triangle": "Dreieck",
              "diamond": "Diamant",
              "pin": "Stift",
              "arrow": "Pfeil",
              "none": "Niemand"
            },
            "pointSize": "Wendepunktgröße",
            "smoothLine": "Glatte Linie"
          },
          "scatter": {
            "bubbleMax": "Große Bubbles",
            "bubbleMin": "Kleine Bubbles",
            "max": "Maximum",
            "min": "Minimum",
            "scale": "Streudiagramm"
          },
          "funnel": {
            "minSize": "Minimale Breite",
            "maxSize": "Maximale Breite"
          },
          "pie": {
            "insideRadiusRatio": "Verhältnis Innendurchmesser",
            "rotateAngle": "Rotierender Winkel",
            "selectArea": "Bereich auswählen",
            "ispop": "Knallt es?",
            "percentLabel": "Prozent-Label",
            "roseType": "Rosenmustertyp",
            "area": "Bereich",
            "radius": "Radius",
            "labelType": "Etikettentyp",
            "dataName": "Klassifizierung",
            "value": "Wert"
          },
          "gauge": {
            "gaugeMin": "Min Skalierung",
            "gaugeMax": "Max Skalierung",
            "gaugeColor": "Messfarbe"
          }
        },
        "tagSetting": {
          "title": "Etiketteneingenschaft",
          "tagPostion": "Etikettenposition",
          "tagShow": "Etiketten anzeigen",
          "tagPostionList": {
            "hidden": "Verbergen",
            "outside": "Ausserhalb",
            "right": "Rechts",
            "left": "Links",
            "top": "Oben",
            "inside": "Innerhalb",
            "bottom": "Unten"
          }
        },
        "tableData": {
          "import": "Importieren",
          "localImport": "vom lokalen Gerät importieren",
          "output": "Exportieren",
          "outputExcel": "XLSX exportiern",
          "outputcsv": "CSV exportieren"
        },
        "coordinate": {
          "lineColor": "Achsenfarbe",
          "cartesianTitle": "Kartesisches Koordinatensyste",
          "radarTitle": "Radarkoordinatensystem",
          "x": "X-Achse",
          "y": "Y-Achse",
          "name": "Festlegen",
          "namePosition": "Position festlegen",
          "shaft": "In der Mitte der Achse",
          "shaftTail": "Achsenende",
          "max": "Maximum",
          "min": "Minimum",
          "segments": "Anzahl der Segmente",
          "showSplit": "Split zeigen",
          "showScale": "Skalierung zeigen",
          "showAxisLine": "Achslinie zeigen",
          "shape": "Skalierung koordinieren",
          "polygon": "Polygon",
          "circular": "Zirkel"
        },
        "dataFormat": {
          "title": "Datenformat",
          "normal": "Normal",
          "delimiter": "Trennzeichen",
          "abbreviation": "Abkürzung",
          "accuracy": "Richtigkeit",
          "percentileThousand": "Tausendstel",
          "percentage": "Hundertstel",
          "digit": "Zehntel",
          "bit": "Eintel",
          "decade": "Zehner",
          "hundred": "Hunderter",
          "percent": "Prozent",
          "axisPrefixSuffix": "Achslabel Prefix / Suffix",
          "valuePrefixSuffix": "DatenlabelPrefix/Suffix",
          "preUnit": "Präfixeinheit",
          "sufUnit": "Suffixeinheit"
        },
        "colorMapping": {
          "title": "Farbzuordnung",
          "createTable": "Mapping-Tabelle generieren",
          "type": "Art",
          "subsection": "Unterabschnitt",
          "continuity": "Verlauf",
          "max": "Maximum",
          "min": "Minimum",
          "increase": "Wachsender Unterabschnitt",
          "width": "Breite",
          "height": "Höhe",
          "H": "Horizontal",
          "V": "Vertikal",
          "none": "Verbergen",
          "position": "Position",
          "higher": "Höhere Position",
          "lower": "Niedrigere Position"
        }
      }
    },
    "continuous": "Kontinuierliche Farbe",
    "piecewise": "Segmentierte Farbe",
    "refreshMap": "Daten aktualisieren"
  },
  "jp": {
    "mapAttrTitle": "チャートのプロパティ",
    "mapDataTitle": "チャートのデータ",
    "normalAttrTitle": "チャートのプロパティ",
    "normalDataTitle": "チャートのデータ",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "タイプをタイプを変更",
          "column": "縦棒グラフ",
          "bar": "横棒グラフ",
          "line": "折れ線グラフ",
          "fill": "面グラフ",
          "scatter": "散布図",
          "radar": "レーダーチャート",
          "pie": "円グラフ",
          "funnel": "ファンネル チャート"
        },
        "chartStyle": {
          "title": "チャートスタイル",
          "legendPosition": "凡例の位置",
          "legendPositionList": {
            "hidden": "非表示",
            "topCenter": "上中央",
            "topRight": "右上",
            "middleRight": "右中央",
            "bottomCenter": "下中央",
            "middleCenter": "上下中央"
          },
          "sort": "ソート",
          "sortList": {
            "none": "なし",
            "ascending": "昇順",
            "descending": "降順"
          },
          "seriesGap": "系列の間隔",
          "categoryGap": "カテゴリの間隔"
        },
        "mapStyle": {
          "title": "地図スタイル",
          "backgroundColor": "背景色"
        },
        "seriesSetting": {
          "title": "系列の設定",
          "bar": {
            "imgTypeLine": "線",
            "imgTypeBar": "棒"
          },
          "line": {
            "pointShape": "折れ点の形状",
            "pointShapeList": {
              "emptyCircle": "中空円",
              "circle": "円",
              "rect": "四角形",
              "roundRect": "円角四角形",
              "triangle": "三角形",
              "diamond": "ダイヤモンド",
              "pin": "ピン",
              "arrow": "矢印",
              "none": "なし"
            },
            "pointSize": "折れ点のサイズ",
            "smoothLine": "円滑な折れ線"
          },
          "scatter": {
            "bubbleMax": "バブルの最大値",
            "bubbleMin": "バブルの最小値",
            "max": "最大値",
            "min": "最小値",
            "scale": "折れ点ロック"
          },
          "funnel": {
            "minSize": "最大幅",
            "maxSize": "最小幅"
          },
          "pie": {
            "insideRadiusRatio": "内側半径比",
            "rotateAngle": "回転角度",
            "selectArea": "カテゴリを選択",
            "ispop": "ポップアップ",
            "percentLabel": "百分率を表示",
            "roseType": "ローズダイアグラムタイプ",
            "area": "面積",
            "radius": "半径",
            "labelType": "系列のタグタイプ",
            "dataName": "カテゴリー",
            "value": "データ"
          },
          "gauge": {
            "gaugeMin": "ゲージの最小値",
            "gaugeMax": "ゲージの最大値",
            "gaugeColor": "ゲージの色"
          }
        },
        "tagSetting": {
          "title": "凡例の設定",
          "tagPostion": "タグの位置",
          "tagShow": "タグを表示",
          "tagPostionList": {
            "hidden": "非表示",
            "outside": "外",
            "right": "右",
            "left": "左侧",
            "top": "上",
            "inside": "内",
            "bottom": "下"
          }
        },
        "tableData": {
          "import": "インポート",
          "localImport": "ローカルインポート",
          "output": "エクスポート",
          "outputExcel": "XLSXにエクスポート",
          "outputcsv": "CSVにエクスポート"
        },
        "coordinate": {
          "lineColor": "座標の色",
          "cartesianTitle": "2次元直交座標系",
          "radarTitle": "レーダー座標系",
          "x": "X軸",
          "y": "Y軸",
          "name": "タイトル",
          "namePosition": "タイトル位置",
          "shaft": "軸の中央",
          "shaftTail": "軸の末端",
          "max": "上限",
          "min": "下限",
          "segments": "セグメント数",
          "showSplit": "分割線を表示",
          "showScale": "スケールを表示",
          "showAxisLine": "軸線を表示",
          "shape": "座標系形状",
          "polygon": "多辺形",
          "circular": "円"
        },
        "dataFormat": {
          "title": "データ書式",
          "normal": "一般",
          "delimiter": "区切り文字",
          "abbreviation": "略語",
          "accuracy": "精度",
          "percentileThousand": "千分率",
          "percentage": "百分率",
          "digit": "十分率",
          "bit": "一の位",
          "decade": "十の位",
          "hundred": "百の位",
          "percent": "パーセント記号",
          "axisPrefixSuffix": "軸タグの接頭/接尾",
          "valuePrefixSuffix": "データタグの接頭/接尾",
          "preUnit": "接頭単位",
          "sufUnit": "接尾単位"
        },
        "colorMapping": {
          "title": "カラーマッピング",
          "createTable": "マッピング表を生成",
          "type": "タイプ",
          "subsection": "セグメンテーション",
          "continuity": "連続",
          "max": "上限",
          "min": "下限",
          "increase": "増分セグメンテーション",
          "width": "幅",
          "height": "高さ",
          "H": "横",
          "V": "縦",
          "none": "非表示",
          "position": "位置",
          "higher": "高位",
          "lower": "低位"
        }
      }
    },
    "continuous": "連続的な色",
    "piecewise": "段階的な色",
    "refreshMap": "データ更新"
  },
  "es": {
    "mapAttrTitle": "Propiedades",
    "mapDataTitle": "Datos",
    "normalAttrTitle": "Propiedades",
    "normalDataTitle": "Datos",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "Cambiar el tipo de gráfico",
          "column": "Columna",
          "bar": "Barra",
          "line": "Línea",
          "fill": "Área",
          "scatter": "Dispersión",
          "radar": "Araña y Radar",
          "pie": "Pie",
          "funnel": "Embudo"
        },
        "chartStyle": {
          "title": "Estilo Gráfico",
          "legendPosition": "Posición de la leyenda",
          "legendPositionList": {
            "hidden": "Ocultar",
            "topCenter": "Top Center",
            "topRight": "Arriba a la derecha",
            "middleRight": "Medio derecha",
            "bottomCenter": "Centro inferior",
            "middleCenter": "Centro Medio"
          },
          "sort": "Secuencia",
          "sortList": {
            "none": "Ninguno",
            "ascending": "Secuencia ascendente",
            "descending": "Secuencia descendente"
          },
          "seriesGap": "Serie Brecha",
          "categoryGap": "Brecha de categoría"
        },
        "mapStyle": {
          "title": "Estilo de mapa",
          "backgroundColor": "Color de Fondo",
          "lineColor": "Color de linea"
        },
        "mapRegion": {
          "showName": "Mostrar nombre de área",
          "more": "Más"
        },
        "seriesSetting": {
          "title": "Ajustes de la serie",
          "bar": {
            "imgTypeLine": "Línea",
            "imgTypeBar": "Barra"
          },
          "line": {
            "pointShape": "Forma de punto",
            "pointShapeList": {
              "emptyCircle": "Círculo vacío",
              "circle": "Círculo",
              "rect": "Rectángulo",
              "roundRect": "RectoRedondo",
              "triangle": "Triángulo",
              "diamond": "Diamante",
              "pin": "Pin",
              "arrow": "Flecha",
              "none": "Ninguno"
            },
            "pointSize": "Tamaño del punto de inflexión",
            "smoothLine": "Linea suave"
          },
          "scatter": {
            "bubbleMax": "Burbuja máx",
            "bubbleMin": "Burbuja min",
            "max": "Máximo",
            "min": "Mínimo",
            "scale": "Diagrama de dispersión"
          },
          "funnel": {
            "minSize": "Ancho mínimo",
            "maxSize": "Ancho máximo"
          },
          "pie": {
            "insideRadiusRatio": "Relación del diámetro interior",
            "rotateAngle": "Ángulo de rotación",
            "selectArea": "Seleccionar área",
            "ispop": "¿Está estallando?",
            "percentLabel": "Etiqueta de porcentaje",
            "roseType": "Tipo de carta rosa",
            "area": "Área",
            "radius": "Radio",
            "labelType": "Tipo de etiqueta",
            "dataName": "Clasificación",
            "value": "Valor"
          },
          "gauge": {
            "gaugeMin": "Escala de Min",
            "gaugeMax": "Escala máxima",
            "gaugeColor": "Color del indicador"
          }
        },
        "tagSetting": {
          "title": "Etiqueta de propiedad",
          "tagPostion": "Posición de la etiqueta",
          "tagShow": "Mostrar etiqueta",
          "tagPostionList": {
            "hidden": "Ocultar",
            "outside": "Afuera",
            "right": "Derecho",
            "left": "Izquierda",
            "top": "Top",
            "inside": "Dentro",
            "bottom": "fondo"
          }
        },
        "tableData": {
          "import": "Importar",
          "localImport": "Importar desde el dispositivo local",
          "output": "Exportar",
          "outputExcel": "Exportar XLSX",
          "outputcsv": "Exportar CSV"
        },
        "coordinate": {
          "lineColor": "Coordinar color",
          "cartesianTitle": "Sistema de Coordenadas Cartesianas",
          "radarTitle": "Sistema de Coordenadas de Radar",
          "x": "Eje X",
          "y": "Eje Y",
          "name": "Nombre",
          "namePosition": "Nombre Posición",
          "shaft": "En el centro del eje",
          "shaftTail": "Cola del Eje",
          "max": "Máximo",
          "min": "Mínimo",
          "segments": "Número de segmentos",
          "showSplit": "Mostrar división",
          "showScale": "Escala del espectáculo",
          "showAxisLine": "Mostrar AxisLine",
          "shape": "Forma de coordenadas",
          "polygon": "Polígono",
          "circular": "Circular"
        },
        "dataFormat": {
          "title": "Formato de datos",
          "normal": "Normal",
          "delimiter": "Delimitador",
          "abbreviation": "Abreviatura",
          "accuracy": "Precisión",
          "percentileThousand": "Milésimas",
          "percentage": "Centésimas",
          "digit": "Décimos",
          "bit": "Unos",
          "decade": "Dieces",
          "hundred": "Cientos",
          "percent": "Signo de porcentaje",
          "axisPrefixSuffix": "Prefijo/sufijo de la etiqueta de eje",
          "valuePrefixSuffix": "Prefijo/sufijo de la etiqueta de datos",
          "preUnit": "Unidad de Prefijos",
          "sufUnit": "Unidad de Prefijos"
        },
        "colorMapping": {
          "title": "Mapeo de colores",
          "createTable": "Generar tabla de mapeo",
          "type": "Escriba",
          "subsection": "Subsección",
          "continuity": "Continuidad",
          "max": "Máximo",
          "min": "Minumum",
          "increase": "Subsección creciente",
          "width": "Ancho",
          "height": "Altura",
          "H": "Horizontal",
          "V": "Vertical",
          "none": "Ocultar",
          "position": "Posición",
          "higher": "Posición superior",
          "lower": "Posición inferior"
        }
      }
    },
    "continuous": "Color continuo",
    "piecewise": "Color de segmento",
    "refreshMap": "Actualizar datos"
  },
  "pt": {
    "mapAttrTitle": "Propriedades",
    "mapDataTitle": "Dados",
    "normalAttrTitle": "Propriedades",
    "normalDataTitle": "Dados",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "Alterar Tipo de Gráfico",
          "column": "Coluna",
          "bar": "Barra",
          "line": "Linha",
          "fill": "Área",
          "scatter": "Dispersão",
          "radar": "Aranha e Radar",
          "pie": "Setores",
          "funnel": "Funil"
        },
        "chartStyle": {
          "title": "Estilo de Gráfico",
          "legendPosition": "Posição da Legenda",
          "legendPositionList": {
            "hidden": "Esconder",
            "topCenter": "Centro Superior",
            "topRight": "Direito Superior",
            "middleRight": "Meio Direita",
            "bottomCenter": "Centro Inferior",
            "middleCenter": "Centro Meio"
          },
          "sort": "Sequência",
          "sortList": {
            "none": "Nenhum",
            "ascending": "Sequência Ascendente",
            "descending": "Sequência Descendente"
          },
          "seriesGap": "Intervalo de Série",
          "categoryGap": "Intervalo de Categoria"
        },
        "mapStyle": {
          "title": "Estilo de Mapa",
          "backgroundColor": "Fundo",
          "lineColor": "Cor da borda"
        },
        "mapRegion": {
          "showName": "Mostrar o nome da região",
          "more": "mais"
        },
        "seriesSetting": {
          "title": "Configurações de Série",
          "bar": {
            "imgTypeLine": "Linha",
            "imgTypeBar": "Barra"
          },
          "line": {
            "pointShape": "Forma do Ponto",
            "pointShapeList": {
              "emptyCircle": "Círculo Vazio",
              "circle": "Círculo",
              "rect": "Rectângulo",
              "roundRect": "Rectângulo Arredondado",
              "triangle": "Triângulo",
              "diamond": "Diamante",
              "pin": "Pino",
              "arrow": "Seta",
              "none": "Nenhum"
            },
            "pointSize": "Inflexão do Tamanho do Ponto",
            "smoothLine": "Linha Uniforme"
          },
          "scatter": {
            "bubbleMax": "Máximo de Bolha",
            "bubbleMin": "Mínimo de Bolha",
            "max": "Máximo",
            "min": "Mínimo",
            "scale": "Gráfico de Dispersão"
          },
          "funnel": {
            "minSize": "Altura Mínima",
            "maxSize": "Altura Máxima"
          },
          "pie": {
            "insideRadiusRatio": "Taxa de Diâmetro Interior",
            "rotateAngle": "Rodar Ângulo",
            "selectArea": "Selecionar Área",
            "ispop": "Está rebentando?",
            "percentLabel": "Etiqueta de Percentagem",
            "roseType": "Tipo de Diagrama de Rosa",
            "area": "Área",
            "radius": "Raio",
            "labelType": "Tipo de Etiqueta",
            "dataName": "Classificação",
            "value": "Valor"
          },
          "gauge": {
            "gaugeMin": "Escala Mínima",
            "gaugeMax": "Escala Máxima",
            "gaugeColor": "Cor de Gauge"
          }
        },
        "tagSetting": {
          "title": "Propriedade de Identificador",
          "tagPostion": "Posição de Identificador",
          "tagShow": "Mostrar Identificador",
          "tagPostionList": {
            "hidden": "Esconder",
            "outside": "Fora",
            "right": "Direita",
            "left": "Esquerda",
            "top": "Topo",
            "inside": "Dentro",
            "bottom": "fundo"
          }
        },
        "tableData": {
          "import": "Importar",
          "localImport": "Importar de Dispositivo Local",
          "output": "Exportar",
          "outputExcel": "Exportar XLSX",
          "outputcsv": "Exportar CSV"
        },
        "coordinate": {
          "lineColor": "Cor da Linha",
          "cartesianTitle": "Sistema de Coordenadas Cartesianas",
          "radarTitle": "Sistema de Coordenação de Radar",
          "x": "Eixo X",
          "y": "Eixo Y",
          "name": "Nome",
          "namePosition": "Posição do Nome",
          "shaft": "No Meio do Eixo",
          "shaftTail": "Cauda do Eixo",
          "max": "Máximo",
          "min": "Mínimo",
          "segments": "Número de Segmentos",
          "showSplit": "Mostrar Divisão",
          "showScale": "Mostrar Escala",
          "showAxisLine": "Mostrar Linha do Eixo",
          "shape": "Coordenar Forma",
          "polygon": "Polígono",
          "circular": "Circular"
        },
        "dataFormat": {
          "title": "Formato de Dados",
          "normal": "Normal",
          "delimiter": "Delimitador",
          "abbreviation": "Abreviatura",
          "accuracy": "Precisão",
          "percentileThousand": "Milésimos",
          "percentage": "Centésimos",
          "digit": "Décimos",
          "bit": "Unidades",
          "decade": "Dezenas",
          "hundred": "Centenas",
          "percent": "Sinal de Percentagem",
          "axisPrefixSuffix": "Prefixo/Sufixo de Etiqueta do Eixo",
          "valuePrefixSuffix": "Prefixo/Sufixo de Etiqueta dos Dados",
          "preUnit": "Unidade Prefixo",
          "sufUnit": "Unidade Sufixo"
        },
        "colorMapping": {
          "title": "Mapeamento a Cores",
          "createTable": "Gerar Tabela de Mapeamento",
          "type": "Tipo",
          "subsection": "Subseção",
          "continuity": "Continuidade",
          "max": "Máximo",
          "min": "Mínimo",
          "increase": "Subseção Crescente",
          "width": "Largura",
          "height": "Altura",
          "H": "Horizontal",
          "V": "Vertical",
          "none": "Esconder",
          "position": "Posição",
          "higher": "Posição Superior",
          "lower": "Posição Inferior"
        }
      }
    },
    "continuous": "Contínuo",
    "piecewise": "Por Troços",
    "refreshMap": "Atualizar mapa"
  },
  "it": {
    "mapAttrTitle": "Proprietà",
    "mapDataTitle": "Dati",
    "normalAttrTitle": "Proprietà",
    "normalDataTitle": "Dati",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "Cambia Tipo di Diagramma",
          "column": "Colonne",
          "bar": "Barre",
          "line": "Linee",
          "fill": "Area",
          "scatter": "Dispersione",
          "radar": "Radar",
          "pie": "Torta",
          "funnel": "Imbuto"
        },
        "chartStyle": {
          "title": "Stile Diagramma",
          "legendPosition": "Posizione Legenda",
          "legendPositionList": {
            "hidden": "Nascondi",
            "topCenter": "In Alto al Centro",
            "topRight": "In Alto a Destra",
            "middleRight": "Centro - Destra",
            "bottomCenter": "In Basso al Centro",
            "middleCenter": "In Mezzo al Centro"
          },
          "sort": "Sequenza",
          "sortList": {
            "none": "Nessuna",
            "ascending": "Sequenza Ascendente",
            "descending": "Sequenza Discendente"
          },
          "seriesGap": "Interruzione di Serie",
          "categoryGap": "Interruzione di Categoria"
        },
        "mapStyle": {
          "title": "Stile Mappa",
          "backgroundColor": "Sfondo"
        },
        "seriesSetting": {
          "title": "Impostazioni Serie",
          "bar": {
            "imgTypeLine": "Linea",
            "imgTypeBar": "Barra"
          },
          "line": {
            "pointShape": "Forma del Punto",
            "pointShapeList": {
              "emptyCircle": "Cerchio Vuoto",
              "circle": "Cerchio",
              "rect": "Rettangolo",
              "roundRect": "Rettangolo Arrotondato",
              "triangle": "Triangolo",
              "diamond": "Rombo",
              "pin": "Puntina",
              "arrow": "Freccia",
              "none": "Nessuna"
            },
            "pointSize": "Dimensione Punto di Inflessione",
            "smoothLine": "Linea Uniforme"
          },
          "scatter": {
            "bubbleMax": "Bolle Max",
            "bubbleMin": "Bolle Min",
            "max": "Massimo",
            "min": "Minimo",
            "scale": "Diagramma di Dispersione"
          },
          "funnel": {
            "minSize": "Larghezza Minima",
            "maxSize": "Larghezza Massima"
          },
          "pie": {
            "insideRadiusRatio": "Nel Rapporto del Diametro",
            "rotateAngle": "Ruota Angolo",
            "selectArea": "Seleziona Area",
            "ispop": "È sporgente?",
            "percentLabel": "Etichetta Percentuale",
            "roseType": "Tipo Diagramma a Rosa",
            "area": "Area",
            "radius": "Raggio",
            "labelType": "Tipo Etichetta",
            "dataName": "Classificazione",
            "value": "Valore"
          },
          "gauge": {
            "gaugeMin": "Scala Minima",
            "gaugeMax": "Scala Massima",
            "gaugeColor": "Colore Misuratore"
          }
        },
        "tagSetting": {
          "title": "Proprietà Tag",
          "tagPostion": "Posizione Tag",
          "tagShow": "Mostra Tag",
          "tagPostionList": {
            "hidden": "Nascondi",
            "outside": "Fuori",
            "right": "Destra",
            "left": "Sinistra",
            "top": "In Alto",
            "inside": "Dentro",
            "bottom": "In Basso"
          }
        },
        "tableData": {
          "import": "Importa",
          "localImport": "Importa da Dispositivo Locale",
          "output": "Esporta",
          "outputExcel": "Esporta in XLSX",
          "outputcsv": "Esporta in CSV"
        },
        "coordinate": {
          "lineColor": "Colore coordinato",
          "cartesianTitle": "Sistema Coordinate Cartesiane",
          "radarTitle": "Sistema Coordinate Radio",
          "x": "Asse X",
          "y": "Asse Y",
          "name": "Nome",
          "namePosition": "Posizione Nome",
          "shaft": "In Mezzo all'Asse",
          "shaftTail": "Estremità dell'Asse",
          "max": "Massimo",
          "min": "Minimo",
          "segments": "Numero di Segmenti",
          "showSplit": "Mostra Divisione",
          "showScale": "Mostra Scala",
          "showAxisLine": "Mostra Linea dell'Asse",
          "shape": "Forma Coordinate",
          "polygon": "Poligonale",
          "circular": "Circolare"
        },
        "dataFormat": {
          "title": "Formato Data",
          "normal": "Normale",
          "delimiter": "Delimitatore",
          "abbreviation": "Abbreviazione",
          "accuracy": "Precisione",
          "percentileThousand": "Millesimi",
          "percentage": "Centesimi",
          "digit": "Decimi",
          "bit": "Unità",
          "decade": "Decine",
          "hundred": "Centinaia",
          "percent": "Segno Percentuale",
          "axisPrefixSuffix": "Prefisso/Suffisso Etichetta Asse",
          "valuePrefixSuffix": "Prefisso/Suffisso Etichetta Dati",
          "preUnit": "Unità Prefisso",
          "sufUnit": "Unità Suffisso"
        },
        "colorMapping": {
          "title": "Mappatura Colore",
          "createTable": "Genera Tabella di Mappatura",
          "type": "Tipo",
          "subsection": "Sottosezione",
          "continuity": "Continuità",
          "max": "Massimo",
          "min": "Minimo",
          "increase": "Aumento Sottosezione",
          "width": "Larghezza",
          "height": "Altezza",
          "H": "Orizzontale",
          "V": "Verticale",
          "none": "Nascondi",
          "position": "Posizione",
          "higher": "Posizione Più Alta",
          "lower": "Posizione Più Bassa"
        }
      }
    },
    "continuous": "Continuo",
    "piecewise": "Segmentato",
    "refreshMap": "Aggiorna dati"
  },
  "tw": {
    "mapAttrTitle": "地圖屬性",
    "mapDataTitle": "地圖數據",
    "normalAttrTitle": "圖表屬性",
    "normalDataTitle": "圖表數據",
    "EChartSet": {
      "content": {
        "changeType": {
          "title": "改變類型",
          "column": "柱狀圖",
          "bar": "條形圖",
          "line": "折線圖",
          "fill": "面積圖",
          "scatter": "散點圖",
          "radar": "雷達圖",
          "pie": "餅圖",
          "funnel": "漏斗圖"
        },
        "chartStyle": {
          "title": "圖表樣式",
          "legendPosition": "圖例位置",
          "legendPositionList": {
            "hidden": "隱藏",
            "topCenter": "頂部中間",
            "topRight": "右側頂部",
            "middleRight": "右側中間",
            "bottomCenter": "底部中間",
            "middleCenter": "居中"
          },
          "sort": "排序",
          "sortList": {
            "none": "無",
            "ascending": "正序",
            "descending": "逆序"
          },
          "seriesGap": "序列間距",
          "categoryGap": "分類間距"
        },
        "mapStyle": {
          "title": "地圖樣式",
          "backgroundColor": "背景顏色",
          "lineColor": "輪廓線顏色"
        },
        "mapRegion": {
          "showName": "顯示地區名稱",
          "more": "更多"
        },
        "seriesSetting": {
          "title": "序列設置",
          "bar": {
            "imgTypeLine": "線形圖",
            "imgTypeBar": "柱狀圖"
          },
          "line": {
            "pointShape": "拐點形狀",
            "pointShapeList": {
              "emptyCircle": "空心圓",
              "circle": "圓形",
              "rect": "矩形",
              "roundRect": "圓角矩形",
              "triangle": "三角形",
              "diamond": "菱形",
              "pin": "圖釘",
              "arrow": "箭頭",
              "none": "無"
            },
            "pointSize": "拐點大小",
            "smoothLine": "平滑曲線"
          },
          "scatter": {
            "bubbleMax": "氣泡最大值",
            "bubbleMin": "氣泡最小值",
            "max": "最大值",
            "min": "最小值",
            "scale": "原點鎖定"
          },
          "funnel": {
            "minSize": "最小寬度",
            "maxSize": "最大寬度"
          },
          "pie": {
            "insideRadiusRatio": "內徑比值",
            "rotateAngle": "旋轉角度",
            "selectArea": "選擇區域",
            "ispop": "是否彈出",
            "percentLabel": "百分比顯示",
            "roseType": "玫瑰圖類型",
            "area": "面積",
            "radius": "半徑",
            "labelType": "序列標籤類型",
            "dataName": "分類",
            "value": "數據"
          },
          "gauge": {
            "gaugeMin": "儀表下限",
            "gaugeMax": "儀表上限",
            "gaugeColor": "儀錶盤顏色"
          }
        },
        "tagSetting": {
          "title": "圖例設置",
          "tagPostion": "標籤位置",
          "tagShow": "顯示標籤",
          "tagPostionList": {
            "hidden": "隱藏",
            "outside": "外側",
            "right": "右側",
            "left": "左側",
            "top": "頂部",
            "inside": "內部",
            "bottom": "底部"
          }
        },
        "tableData": {
          "import": "導入",
          "localImport": "本地導入",
          "output": "導出",
          "outputExcel": "導出XLSX",
          "outputcsv": "導出CSV"
        },
        "coordinate": {
          "lineColor": "坐標顏色",
          "cartesianTitle": "二維直角坐標系",
          "radarTitle": "雷達圖坐標系",
          "x": "X坐標軸",
          "y": "Y坐標軸",
          "name": "名稱",
          "namePosition": "名稱位置",
          "shaft": "軸中",
          "shaftTail": "軸尾",
          "max": "上限",
          "min": "下限",
          "segments": "分段數量",
          "showSplit": "顯示分割線",
          "showScale": "顯示刻度",
          "showAxisLine": "顯示軸線",
          "shape": "坐標系形狀",
          "polygon": "多邊形",
          "circular": "圓"
        },
        "dataFormat": {
          "title": "數據格式",
          "normal": "普通",
          "delimiter": "分隔符",
          "abbreviation": "縮寫",
          "accuracy": "精度",
          "percentileThousand": "千分位",
          "percentage": "百分位",
          "digit": "十分位",
          "bit": "個位",
          "decade": "十位",
          "hundred": "百位",
          "percent": "百分號",
          "axisPrefixSuffix": "軸標籤前/後綴",
          "valuePrefixSuffix": "數據標籤前/後綴",
          "preUnit": "前綴單位",
          "sufUnit": "後綴單位"
        },
        "colorMapping": {
          "title": "顏色設置",
          "createTable": "生成映射表",
          "type": "類型",
          "subsection": "分段",
          "continuity": "連續",
          "max": "上限",
          "min": "下限",
          "increase": "遞增分段",
          "width": "顏色條寬度",
          "height": "顏色條高度",
          "H": "橫向",
          "V": "縱向",
          "none": "隱藏",
          "position": "位置",
          "higher": "上限顏色",
          "lower": "下限顏色"
        }
      }
    },
    "continuous": "連續顏色",
    "piecewise": "分段顏色",
    "refreshMap": "刷新數據"
  }
}
</i18n>
